import axios from "axios";
import store from "@/store";
import {
  GetLayerInfoById,
  GetGData,
  getDataDetail_GDB,
  getAllTableData,
  getGDataObject,
} from "./api";
import LonLatConversion from "./LonLatConversion.js";
import commonB from "./common-addition.js";
import {
  point as trufPoint,
  lineString,
  polygon as trufPolygon,
  length as truflength,
  booleanPointInPolygon,
  booleanIntersects,
} from "@turf/turf";
var isProjectionPromise = false;
var allLayerInfoList = [];
var lastLevel = null;
var lastExtent = null;
var currentOperation = null;
var dragEndTimestamp = 0;
var lastOperation = null;
var nowOffsetX = 0;
var nowOffsetY = 0;
var zoomEndTimestamp = 0;
var clientX = 0;
var clientY = 0;
var current_tool = null;
var isInit = false;
var mapCoordinateNumber = 0;
var map = null;
var shareStatus = [];
var TileData = []; //剔除数据库数据后的切片数据，可用于切片重新绘制，包括layerID、点线面类型、切片行列、值、偏移量
var noDrawData = []; //未绘制的数据
var lastPickedData = []; //当前拾取的canvas数据，用于点击选中
// 数据库图层
const databaseLayer = {
  initLayer: function initLayer(url, token, mapObj) {
    if (!url) {
      return { addVecLayer: urlErr };
    } else {
      gispai_baseURL = url;
    }
    if (!token) {
      return { addVecLayer: tokenErr };
    } else {
      gispai_token = token;
    }
    map = mapObj;
    //拾取canvas
    createCanvas("highlight", "scale");
    return { addVecLayer };
  },
};

// url错误提醒
function urlErr() {
  console.error("url信息异常");
}

// token错误提醒
function tokenErr() {
  console.error("token信息异常");
}

function addVecLayer(layerIdList, type) {
  // console.log(map.__tileInfo.lods);
  if(type == 'init') {
    allLayerInfoList = []
  }
  mapListeningEvent()
  if (!isInit) init();
  layerIdList.forEach((layer) => {
    //根据layerID，获得图层符号化信息GDataID
    GetLayerInfoById({ layerId: layer.layerId }).then((res) => {
      if (res.data.Data) {
        let resLayerInfo = JSON.parse(res.data.Data);
        resLayerInfo.zIndex = layer.zIndex
        allLayerInfoList.push(resLayerInfo);
        let params = {
          UserId: store.state.user.mapUserId,
          GDataid: resLayerInfo.GDataId,
          type: 1,
          mapDocId: resLayerInfo.MapDocId,
        };
        getDataDetail_GDB(params).then(async (res) => {
          let data = res.data;
          if (data.state.Status == 1) {
            var gdata = data.Gdata_data;
            let coordinate = gdata.Coordinate;
            let obj = {
              coordinate: parseInt(coordinate),
              minscale: gdata.Minscale,
              levelRange: gdata.Classification,
            };
            let layerIndex = allLayerInfoList.findIndex(
              (ele) => ele.Id == layer.layerId
            );
            let layerInfo = allLayerInfoList[layerIndex];
            allLayerInfoList[layerIndex] = Object.assign(layerInfo, obj);
            setScale(layerInfo.Id, data);

            // let layerNodes = getVetorLayerNode(store.state.dataTreeData);
            // let index = layerNodes.findIndex((node) => node.id === layerData.Id);
            // let flag = getChecked(layerNodes[index], layerInfo);
            if (isInScale(layerInfo.Id)) {
              // if (layerInfo.IsConcealed == 0) {
              var vdata = {
                id: layerInfo.Id,
                gDataId: layerInfo.GDataId,
                geoType: layerInfo.GeoType,
              };
              let timestamp = Date.now();
              // 判断是否切片
              if (!layerInfo.IsTileMode) {
                getAllDataFromServer(layer.layerId, "init");
              } else {
                //编辑操作后的数据
                await getChangedData(layer.layerId, "init").then((res) => {
                  //行列号数据
                  addTileData(vdata, "init", timestamp);
                });
              }
              // }
            }
          } else {
            Message({
              type: "error",
              message: data.state.Msg,
            });
          }
        });
      }

      // getAllDataFromServer(layerId, "init");
    });
  });
}

/**
 * @author:yedq
 * @description:初始化数据
 */
function init() {
  isInit = true;
  let esriModule = store.state.esriModule;
  var projectionPromise = esriModule.projection.load();
  projectionPromise.then(function () {
    isProjectionPromise = true;
  });
  // 初始化mapSpatial
  mapCoordinateNumber = map.spatialReference.wkid;

  lastLevel = map.getLevel();
  lastExtent = map.extent;
  ZHT_lastExtent = map.extent;
  store.dispatch("zoomEndTimestamp", zoomEndTimestamp);
}

/**
 * @author:yedq
 * @description:初始化map监听事件
 */
function mapListeningEvent() {
  map.on("extent-change", function (e) {
    var dragParams = {};
    if (e.lod.level == lastLevel) {
      //拖拽
      // if (isLocatePosition == "locatePosition") { //点击定位时触发
      //     currentOperation = "drag";
      //     dragChange(lastExtent, e.extent, dragEndTimestamp);
      // } else {
      if (
        e.delta != null &&
        (Math.abs(e.delta.x) > 1 || Math.abs(e.delta.y) > 1)
      ) {
        currentOperation = "drag";
        dragChange(lastExtent, e.extent, dragEndTimestamp);
        dragParams.firstDragTimestamp = dragEndTimestamp;
        dragParams.lastExtent = lastExtent;
        dragParams.nowExtent = e.extent;
        store.dispatch("dragParams", dragParams);
        // setTimeout(() => {
        //   if (store.state.IsShowMaterial) initSuCai(store.state.sucaiObjList);
        // }, 100);
      }
      // }
    } else {
      //放大缩小清除切片canvas、缓存数据
      var canvasCtn = document.getElementsByClassName("gispaiLayer");
      if (canvasCtn && canvasCtn.length > 0) {
        for (var i = 0; i < canvasCtn.length; i++) {
          canvasCtn[i].remove();
          i = i - 1;
        }
        TileCanvasCache = [];
        ChangedCanvasCache = [];
      }
      //缩放过程根据比例尺显隐
      scaleHandleChange();
      currentOperation = "scale";
      // store.dispatch("zoomEndTimestamp", zoomEndTimestamp);
      //为了能够在比例尺设置的情况下，能够获取到数据延迟100毫秒设置zoomEndTimestamp,置空当前图层数据库请求时间戳以获得数据
      setTimeout(() => {
        //缩放操作
        extentChange(zoomEndTimestamp);
        // if (store.state.IsShowMaterial) initSuCai(store.state.sucaiObjList);
      }, 100);
      dragParams.firstDragTimestamp = zoomEndTimestamp;
      dragParams.lastExtent = lastExtent;
      dragParams.nowExtent = e.extent;
      store.dispatch("dragParams", dragParams);
      // if (IsToolActive && current_tool == "movepolygons") {
      //   commonB.removeMoveCanvas()
      //   store.dispatch('setCanMove', false)
      // }
    }
    lastOperation = currentOperation;
    lastLevel = e.lod.level;
    lastExtent = e.extent;
    // //右键菜单栏消失
    // var info = {
    //     type: 0,
    //     top: 0,
    //     left: 0,
    //     show: false,
    //     isEditing: ISStartEditing,
    //     isShowcopy: false,
    //     isNode: false,
    //     isRemoveSingle: false,
    //     isRemoveMulit: false,
    //     isinsertNode: false,
    //     isrectangle: current_tool == null || current_tool == '',
    //     isTrace: false,
    // }
    // store.commit('setMapRightMenu', info)
  });
  map.on("mouse-down", function (evt) {
    clientX = evt.clientX;
    clientY = evt.clientY;
  });
  map.on("mouse-drag", function (evt) {
    //canvas偏移
    handleOffsetEvent(evt, clientX, clientY);
    clientX = evt.clientX;
    clientY = evt.clientY;
  });
  //地图事件 鼠标移动
  // map.on("mouse-move", function (evt) {
  //   if (evt.mapPoint == null || evt.mapPoint.x == null) return;
  //   var x = evt.mapPoint.x.toFixed(4);
  //   var y = evt.mapPoint.y.toFixed(4);
  //   // 获取当前地图等级
  //   var scale = parseInt(map.getScale());
  //   /**
  //    * 存储当前鼠标位置的坐标
  //    */
  //   // 将x和y转换为地理坐标
  //   let esriModel = store.state.esriModule;
  //   let point = new esriModel.Point(
  //     parseFloat(x),
  //     parseFloat(y),
  //     map.spatialReference
  //   );
  //   // if (transform.key === 102100) {
  //   //   point = esriModel.webMercatorUtils.webMercatorToGeographic(point);
  //   // }
  //   store.commit("setMovePosition", [
  //     point.x.toFixed(4),
  //     point.y.toFixed(4),
  //     scale,
  //     map.getZoom(),
  //   ]);
  //   let mappoint = evt.mapPoint;
  //   let point2 = map.toScreen(mappoint);
  //   let client = {
  //     clientX: evt.clientX,
  //     clientY: evt.clientY
  //   }
  //   mouseMoveEvent(point2, client);
  // });
}

/**
 * @author: wyt
 * @description:加载数据库数据
 * @export
 * @param {*} layerId 图层Id
 * @param {*} type 类型 init drag redraw
 */
function getAllDataFromServer(layerId, type) {
  //判断该图层是否在比例尺内
  if (!isInScale(layerId)) {
    return;
  }
  // 清除有关弧线的相关信息
  clearArcLineArr(layerId, null, "layer");
  // ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);

  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  //转换map的extent
  let coordinate = layerInfo.Coordinate;
  var extent = map.extent;
  if (mapCoordinateNumber != coordinate) {
    extent = convertMapExtent(coordinate);
  }
  if (extent == null) {
    return;
  }

  var timeStamp = localStorage.getItem("timestamp" + layerId + "_2");

  if (type != "init" && type != "reload") {
    //单独更新ChangedData
    updateChangedData(extent, layerId, layerInfo);
    //绘制数据库数据，并对现有的切片canvas进行纠偏
    drawChangedData(layerInfo.Id);
    //标注canvas重置位置
    labelCanvasoffset(layerInfo.Id);
    clearLabelCanvas(layerInfo.Id);
    if (type === "drag") {
      var changeD = AllChangedData.find((val) => val.layerId === layerId);
      if (!changeD) return;
      var viewdata = changeD.data.filter((ele) => ele.IsInView == true);
      //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
      if (viewdata) {
        appendLabelData(layerId, viewdata, "Attribute").then((labelData) => {
          layerId, viewdata, "Attribute", type;
          DrawLayerLabel(layerId, viewdata, "Attribute", type);
        });
      }
    } else {
      if (type != "redraw") {
        var changeD = AllChangedData.find((val) => val.layerId === layerId);
        if (changeD) {
          DrawLayerLabel(layerId, changeD.data, "Attribute", type);
          if (type === "scale") {
            if (allTotalLayerHasPosted == allTotalLayerPost) {
              stopDrawText();
            }
          }
        }
      }
    }
    stopDrawText();
    return;
  }
  let params = {
    UserId: store.state.user.mapUserId,
    GDataId: layerInfo.GDataId,
    GDataName: "",
    type: 1,
    mapDocId: layerInfo.MapDocId,
    // timestamp: timeStamp
  };
  // 为后面取消请求做准备
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  cancleToken.push(source);

  GetGData(params, source.token).then(async (res) => {
    // 保存下次请求的时间戳
    localStorage.setItem("timestamp" + layerId, res.data.timestamp);
    localStorage.setItem("clienttimestamp" + layerId, new Date().getTime());

    ZHT_ChangedDelData = res.data.deleteids;
    var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
    //处理数据库缓存数据,更新AllChangedData和ChangedData
    var reslist = [];
    if (res.data.Data) {
      reslist = JSON.parse(res.data.Data);
    }
    if ((reslist && reslist.length > 0) || !timeStamp) {
      updateAllChangedData(reslist, extent, layerId, layerInfo);
    } else {
      //单独更新ChangedData
      updateChangedData(extent, layerId, layerInfo);
    }
    //设置该图层已加载数据
    layerInfo.hasLoadData = true;
    //绘制数据库数据，并对现有的切片canvas进行纠偏
    drawChangedData(layerInfo.Id);

    //标注canvas重置位置
    labelCanvasoffset(layerInfo.Id);
    clearLabelCanvas(layerInfo.Id);
    if (type === "drag") {
      var changeD = AllChangedData.find((val) => val.layerId === layerId);
      if (!changeD) return;

      var viewdata = changeD.data.filter((ele) => ele.IsInView == true);

      //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
      if (viewdata) {
        await appendLabelData(layerId, viewdata, "Attribute").then(
          (labelData) => {
            layerId, viewdata, "Attribute", type;
            DrawLayerLabel(layerId, viewdata, "Attribute", type);
          }
        );
      } else {
        // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
        //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
        // });
      }
    } else {
      if (type != "redraw") {
        var changeD = AllChangedData.find((val) => val.layerId === layerId);
        if (changeD) {
          var viewdata = changeD.data.filter((ele) => ele.IsInView == true);
          DrawLayerLabel(layerId, viewdata, "Attribute", type);
          if (type === "scale") {
            if (allTotalLayerHasPosted == allTotalLayerPost) {
              stopDrawText();
            }
          }
        }
      }
    }
    stopDrawText();
  });
}

/**
 * @author: wyt
 * @description:创建canvas、绘制数据库读取的数据
 * @param {*} data 数据
 * @param {*} layerId 图层id
 */
function drawChangedData(layerId) {
  //数据排序
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  var pdiv = document.querySelector("#mapView");
  var canvasCtn = createTiledCanvas(layerId);
  var canvas = document.getElementById(layerId + "_changed");

  const tempCanvas = document.createElement("canvas"); //缓存 canvas
  tempCanvas.width = pdiv.clientWidth;
  tempCanvas.height = pdiv.clientHeight;
  tempCanvas.style.left = "0px";
  tempCanvas.style.top = "0px";
  tempCanvas.style.position = "absolute";

  var index = AllChangedData.findIndex((x) => x.layerId == layerId);
  var newData = [];
  if (index >= 0) {
    newData = AllChangedData[index].data.filter((ele) => ele.IsInView == true);
  }

  if (canvas) {
    // 当图层中最后一个数据被删除的时候清理canvas
    if (newData && !newData.length) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stopDrawText();
    }
  } else {
    canvas = document.createElement("canvas");
    canvas.className = "gispaiLayer" + " changedCanvas";
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    canvas.setAttribute("id", layerId + "_changed");
    canvas.setAttribute("targetType", "data");
    canvas.width = pdiv.clientWidth;
    canvas.height = pdiv.clientHeight;
    canvas.style.position = "absolute";
    canvasCtn.append(canvas);
  }

  //若范围内没有数据库数据，对所有切片数据canvas进行纠正偏移，若有数据库数据，则统一在数据库数据绘制后纠偏
  if (newData.length > 0) {
    // 先绘制到 tempCanvas
    drawData_Changed(layerId, tempCanvas, layerInfo, newData, canvas);
  } else {
    //对切片数据canvas进行纠偏
    canvas.parentElement.style.top = "0px";
    canvas.parentElement.style.left = "0px";
    var ctnelement = canvas.parentElement.childNodes;
    if (ctnelement && ctnelement.length > 0) {
      var ele = ctnelement;
      for (var k = 0; k < ele.length; k++) {
        if (ele[k].id.indexOf("changed") == -1) {
          var ids = ele[k].id.split("_");
          var eLayerId = +ids[0];
          var eRow = +ids[1];
          var eCol = +ids[2];
          //全局数据在当前范围的行列要做偏移
          var offset = getCoordByRowCol(eRow, eCol);
          ele[k].style.left = offset.offsetX + "px";
          ele[k].style.top = offset.offsetY + "px";
          if (layerInfo.GeoType === "点" || layerInfo.GeoType === "线") {
            ele[k].style.left = offset.offsetX - pointSpace + "px";
            ele[k].style.top = offset.offsetY - pointSpace + "px";
          }
        }
      }
    }

    if (allTotalLayerHasPosted == allTotalLayerPost) {
      stopDrawText();
    }
  }
}

/**
 * @author: wyt
 * @description:创建数据图层外层div
 * @param {*} layerId 图层Id
 */
function createTiledCanvas(layerId) {
  var div = document.querySelector("#mapView_gc");
  if (div == null) return;
  var canvasCtn = document.querySelector(".gispaiLayer_" + layerId);
  if (!canvasCtn) {
    canvasCtn = document.createElement("div");
    canvasCtn.className = "gispaiLayer_" + layerId + " datalayer";
    canvasCtn.style.position = "absolute";
    let layerIndex = allLayerInfoList.findIndex(
      (ele) => ele.Id == layerId
    );
    let layerInfo = allLayerInfoList[layerIndex];
    canvasCtn.style.zIndex = layerInfo.zIndex;
    div.before(canvasCtn);
    //图层排序
    // reorderCanvasLayer();
  }
  // let flag = store.state.dataTreeData[0].checked;
  // if (!flag) {
  //   canvasCtn.style.display = "none";
  // }
  return canvasCtn;
}

/**
 * @description:label图层偏移
 */
function stopDrawText() {
  setTimeout(() => {
    store.dispatch("setDrawingText", "");
  }, 1000);
}

/**
 * @description:修改存在前端的数据库数据AllChangedData（包括修改和删除的数据）
 * @export
 * @param {*} data 数据库数据
 * @param {*} layerId
 * @return {*}
 */
function updateAllChangedData(data, extent, layerId, layerInfo) {
  var singlechangeData = [];
  var currentchangeData = [];
  var changeDataIndex = AllChangedData.findIndex(
    (item) => item.layerId === layerId
  );
  //var currentchangeDataIndex = ChangedData.findIndex(item => item.layerId === layerId);
  if (changeDataIndex > -1) {
    singlechangeData = AllChangedData[changeDataIndex].data;
  }
  // if (currentchangeDataIndex > -1) {
  //   currentchangeData = ChangedData[currentchangeDataIndex].data;
  // }
  var tolerance =
    (extent.xmax - extent.xmin + extent.ymax - extent.ymin) / 1000;
  data = convertChangedData(data, layerId, layerInfo, extent, tolerance);
  for (let index = 0; index < data.length; index++) {
    // 将数据缓存 在label中使用
    var lisVal = data[index];
    var changeFeatureIndex = singlechangeData.findIndex(
      (val) => val.Attr.ID === lisVal.Attr.ID
    );
    if (changeFeatureIndex > -1) {
      singlechangeData.splice(changeFeatureIndex, 1);
      singlechangeData.push(lisVal);
    } else {
      singlechangeData.push(lisVal);
    }
  }
  //更新AllChangedData
  if (changeDataIndex > -1) {
    AllChangedData[changeDataIndex].data = singlechangeData;
  } else {
    var newData = {
      layerId: layerId,
      data: singlechangeData,
    };
    AllChangedData.push(newData);
  }

  // 去除删除掉的数据
  if (ZHT_ChangedDelData && ZHT_ChangedDelData.length > 0) {
    var _changeDataIndex = AllChangedData.findIndex(
      (item) => item.layerId === layerId
    );
    if (_changeDataIndex > -1) {
      var _changeData = AllChangedData[_changeDataIndex].data;
      for (let i = 0; i < _changeData.length; i++) {
        var val = _changeData[i];
        if (ZHT_ChangedDelData && ZHT_ChangedDelData.length) {
          for (let k = 0; k < ZHT_ChangedDelData.length; k++) {
            var delId = ZHT_ChangedDelData[k];
            if (delId === val.Attr.ID) {
              _changeData.splice(i, 1);
              i--;
            }
          }
        }
      }
    }
  }
}

/**
 * @author: wyt
 * @description:数据转化（数据库数据）
 * @param {*} oldData
 * @param {*} layerId
 * @param {*} layerInfo
 */
function convertChangedData(
  oldData,
  layerId,
  layerInfo,
  viewExtent,
  tolerance
) {
  let esriModule = store.state.esriModule;
  let arcline = store.state.arcLineArr;
  var basemapID = -1;
  var newData = [];
  let TransformPosition = new LonLatConversion();
  for (var i = 0; i < oldData.length; i++) {
    if (oldData[i].Shape != null && oldData[i].Shape.length > 0) {
      let newGeo;
      if (layerInfo.GeoType == "点") {
        let geometry = oldData[i].Shape;
        newGeo = new esriModule.Point({
          x: geometry[0],
          y: geometry[1],
          spatialReference: new esriModule.SpatialReference(
            parseInt(layerInfo.Coordinate)
          ),
        });
        newGeo = convertLngLat(
          layerInfo.Coordinate,
          newGeo,
          basemapID,
          TransformPosition
        );
      } else if (layerInfo.GeoType == "线") {
        let geometry = RepairGeo(
          oldData[i].Shape,
          oldData[i].ID,
          layerId,
          layerInfo.Coordinate
        );

        let onj = arcline.find(
          (x) => x.featureId == oldData[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polyline({
            paths: onj.convertNodes,
            spatialReference: map.spatialReference,
          });
        } else {
          newGeo = new esriModule.Polyline({
            paths: geometry,
            spatialReference: new esriModule.SpatialReference(
              parseInt(layerInfo.Coordinate)
            ),
          });
          newGeo = convertLngLat(
            layerInfo.Coordinate,
            newGeo,
            basemapID,
            TransformPosition
          );
        }
      } else {
        let geometry = RepairGeo(
          oldData[i].Shape,
          oldData[i].ID,
          layerId,
          layerInfo.Coordinate
        );
        let onj = arcline.find(
          (x) => x.featureId == oldData[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polygon({
            rings: onj.convertNodes,
            spatialReference: map.spatialReference,
          });
        } else {
          newGeo = new esriModule.Polygon({
            rings: geometry,
            spatialReference: new esriModule.SpatialReference(
              parseInt(layerInfo.Coordinate)
            ),
          });
          newGeo = convertLngLat(
            layerInfo.Coordinate,
            newGeo,
            basemapID,
            TransformPosition
          );
        }
      }
      //判断不会空，防止报错
      if (newGeo) {
        var rings =
          layerInfo.GeoType == "点"
            ? [[[newGeo.x, newGeo.y]]]
            : layerInfo.GeoType == "线"
            ? newGeo.paths
            : newGeo.rings;
        var _attr = oldData[i].Attr;
        if (_attr == null) {
          _attr = { ID: oldData[i].ID };
        }

        let IsInView = false;
        let extentArr = oldData[i].Extent.split(",");
        if (extentArr.length == 1) {
          let geom = new esriModule.Polygon({
            rings: rings,
            spatialReference: new esriModule.SpatialReference(
              layerInfo.coordinate
            ),
          });
          let extent = geom.getExtent();
          let eArr = [];
          eArr.push(extent.xmin);
          eArr.push(extent.ymin);
          eArr.push(extent.xmax);
          eArr.push(extent.ymax);
          extentArr = eArr;
          oldData[i].Extent = eArr.join(",");
        }

        // 获取范围内的数据
        var params = {
          xmin: parseFloat(extentArr[0]),
          ymin: parseFloat(extentArr[1]),
          xmax: parseFloat(extentArr[2]),
          ymax: parseFloat(extentArr[3]),
        };
        if (isInExtent(params, viewExtent, layerInfo, tolerance)) {
          IsInView = true;
        }
        newData.push({
          ID: oldData[i].ID,
          Shape: rings,
          Attr: _attr,
          Extent: oldData[i].Extent,
          IsInView: IsInView,
        });
      }
    }
  }
  return newData;
}

// 颜色转换
function RepairGeo(geom, Id, layerid, coordinate) {
  let list = store.state.arcLineArr;
  var geo = [];
  var flag = false;
  var firstCircle = null;
  for (var m = 0; m < geom.length; m++) {
    var partGeo = [];
    for (var n = 0; n < geom[m].length; n++) {
      if (n + 1 < geom[m].length && n + 2 < geom[m].length) {
        if (geom[m][n].length == 2 && geom[m][n + 1].length == 3) {
          var tmp = [];
          tmp.push({
            x: geom[m][n][0],
            y: geom[m][n][1],
          });
          tmp.push({
            x: geom[m][n + 1][0],
            y: geom[m][n + 1][1],
          });
          tmp.push({
            x: geom[m][n + 2][0],
            y: geom[m][n + 2][1],
          });

          if (
            geom[m][n][0] == geom[m][n + 2][0] &&
            geom[m][n][1] == geom[m][n + 2][1]
          ) {
            //圆
            var s = setArcline(tmp, "circle");
            if (m != 0) {
              let d = locate(tmp); //算圆心
              if (firstCircle != null) {
                let r1 = firstCircle.radius;
                let r2 = d.radius;
                if (Math.abs(r2 - r1) < r1) {
                  s.reverse();
                }
              } else {
                let poly = trufPolygon([geo[0]]);
                let pt1 = trufPoint([d.x, d.y]);
                let fla = booleanPointInPolygon(pt1, poly);
                if (fla) {
                  s.reverse();
                }
              }
            } else {
              firstCircle = locate(tmp);
            }
            if (s != null) {
              s.forEach((item) => {
                partGeo.push(item);
              });
              flag = true;
            }
            n = n + 2;
          } else {
            var s = setArcline(tmp, "arc");
            if (s != null) {
              s.forEach((item) => {
                partGeo.push(item);
              });
              flag = true;
            }
            n = n + 1;
          }
        } else {
          partGeo.push(geom[m][n]);
        }
      } else {
        partGeo.push(geom[m][n]);
      }
    }
    if (partGeo.length > 0) {
      geo.push(partGeo);
    }
    if (flag) {
      let _geom = [];
      let esriModule = store.state.esriModule;
      geom.forEach((item) => {
        let jtemp = [];
        for (let j = 0; j < item.length; j++) {
          let pt = new esriModule.Point(
            item[j][0],
            item[j][1],
            new esriModule.SpatialReference(coordinate)
          );
          pt = convertLngLat(coordinate, pt);
          if (!pt) continue;
          if (item[j].length > 2) {
            jtemp.push([pt.x, pt.y, item[j][2]]);
          } else {
            jtemp.push([pt.x, pt.y]);
          }
        }
        if (jtemp.length > 0) {
          _geom.push(jtemp);
        }
      });
      let _geo = [];
      geo.forEach((item) => {
        let jtemp = [];
        for (let j = 0; j < item.length; j++) {
          let pt = new esriModule.Point(
            item[j][0],
            item[j][1],
            new esriModule.SpatialReference(coordinate)
          );
          pt = convertLngLat(coordinate, pt);
          if (!pt) continue;
          if (item[j].length > 2) {
            jtemp.push([pt.x, pt.y, item[j][2]]);
          } else {
            jtemp.push([pt.x, pt.y]);
          }
        }
        if (jtemp.length > 0) {
          _geo.push(jtemp);
        }
      });
      if (Id != -1) {
        let index = list.findIndex(
          (x) => x.layerId == layerid && x.featureId == Id
        );
        if (index < 0) {
          list.push({
            layerId: layerid,
            featureId: Id,
            originalShpape: geom,
            shape: geo,
            convertShpape: _geom,
            convertNodes: _geo,
          });
        } else {
          list.splice(index, 1);
          list.push({
            layerId: layerid,
            featureId: Id,
            originalShpape: geom,
            shape: geo,
            convertShpape: _geom,
            convertNodes: _geo,
          });
        }
      }
    }
  }
  store.commit("set_arcLineArr", list);
  // geo.forEach(item => {
  //   let df = lineString(item)
  //   let d = booleanClockwise(df)
  //   console.log("Clockwise", d)
  // })
  // console.log("RepairGeo:", Id, geo)
  return geo;
}

/**
 * @author: wyt
 * @description: 坐标转换（要素的坐标转地图上的坐标）
 * @export
 * @param {*} convertCoor 坐标系
 * @param {*} geometry
 * @return {*}
 */
function convertLngLat(convertCoor, geometry, basemapID, TransformPosition) {
  //底图如果是高德、捷泰、腾讯等地图，矢量数据为4490或4326，显示时要进行坐标转换，转到GCJ-02：中国坐标偏移标准
  if (
    basemapID == 4 ||
    basemapID == 5 ||
    basemapID == 6 ||
    basemapID == 7 ||
    basemapID == 8 ||
    basemapID == 9
  ) {
    if (
      geometry.spatialReference.wkid == 4490 ||
      geometry.spatialReference.wkid == 4326
    ) {
      let newPaths = [];
      let oldPathsOrRings = null;
      if (geometry.paths) oldPathsOrRings = geometry.paths;
      if (geometry.rings) oldPathsOrRings = geometry.rings;
      oldPathsOrRings.forEach((path) => {
        let newPath = [];
        path.forEach((pt) => {
          let point = TransformPosition.wgs2gcj(pt[0], pt[1]);
          newPath.push([point.Lon, point.Lat]);
        });
        newPaths.push(newPath);
      });
      if (geometry.paths) geometry.paths = newPaths;
      if (geometry.rings) geometry.rings = newPaths;
    }
  }

  // if (mapCoordinate == geometry.spatialReference.wkid) {
  //   return geometry;
  // }

  let newGeo;
  var esriModule = store.state.esriModule;
  if (convertCoor < 0) {
    let o = store.state.coorList.find((x) => x.Wkid == convertCoor);
    if (o != undefined) {
      if (isProjectionPromise) {
        var outSpatialReference = new esriModule.SpatialReference({
          wkt: o.Wkt,
        });
        geometry.setSpatialReference(outSpatialReference);
        newGeo = esriModule.projection.project(geometry, map.spatialReference);
        return newGeo;
      } else {
        var projectionPromise = esriModule.projection.load();
        projectionPromise.then(function () {
          isProjectionPromise = true;
          newGeo = esriModule.projection.project(
            geometry,
            map.spatialReference
          );
          return newGeo;
        });
      }
    }
  } else {
    if (isProjectionPromise) {
      newGeo = esriModule.projection.project(geometry, map.spatialReference);
      return newGeo;
    } else {
      var projectionPromise = esriModule.projection.load();
      projectionPromise.then(function () {
        isProjectionPromise = true;
        newGeo = esriModule.projection.project(geometry, map.spatialReference);
        return newGeo;
      });
    }
  }
}

/**
 * 转换地图extent坐标
 * @param {*} coordinate 坐标系
 */
function convertMapExtent(coordinate) {
  let esriModule = store.state.esriModule;
  var extent = map.extent;
  var coor = mapCoordinateNumber; //map.spatialReference.wkid

  let xmin = map.extent.xmin;
  let xmax = map.extent.xmax;
  let ymin = map.extent.ymin;
  let ymax = map.extent.ymax;

  if (coor == 4490 || coor == 4326) {
    if (xmin < -180 && xmin > -1000) xmin = -179;
    if (xmax < 1000 && xmax > 180) xmax = 179;

    if (ymin < -90 && ymin > -1000) ymin = -89;
    if (ymax < 1000 && ymax > 90) ymax = 89;
  }
  var geo1 = new esriModule.Point({
    x: xmin,
    y: ymin,
    spatialReference: coor,
  });
  var geo2 = new esriModule.Point({
    x: xmax,
    y: ymax,
    spatialReference: coor,
  });
  if (!coordinate) {
    return null;
  }
  var newGeo1 = TconvertLngLat(coordinate, geo1);
  var newGeo2 = TconvertLngLat(coordinate, geo2);
  if (newGeo1 == null || newGeo2 == null) {
    return null;
  }

  if (newGeo2.x < 0) {
    newGeo2.x = -newGeo2.x;
  }

  extent = {
    xmin: newGeo1.x,
    xmax: newGeo2.x,
    ymin: newGeo1.y,
    ymax: newGeo2.y,
  };
  return extent;
}

function TconvertLngLat(coor, geometry) {
  if (mapCoordinateNumber == coor) {
    return geometry;
  }
  let newGeo;
  var esriModule = store.state.esriModule;
  if (coor < 0) {
    if (!store.state.coorList) {
      return;
    }
    let o = store.state.coorList.find((x) => x.Wkid == coor);
    if (o) {
      if (isProjectionPromise) {
        var outSpatialReference = new esriModule.SpatialReference({
          wkt: o.Wkt,
        });
        newGeo = esriModule.projection.project(geometry, outSpatialReference);
        return newGeo;
      } else {
        var projectionPromise = esriModule.projection.load();
        projectionPromise.then(function () {
          isProjectionPromise = true;
          newGeo = esriModule.projection.project(geometry, outSpatialReference);
          return newGeo;
        });
      }
    }
  } else {
    var outSpatialReference = new esriModule.SpatialReference(coor);
    if (isProjectionPromise) {
      newGeo = esriModule.projection.project(geometry, outSpatialReference);
      return newGeo;
    } else {
      var projectionPromise = esriModule.projection.load();
      projectionPromise.then(function () {
        isProjectionPromise = true;
        newGeo = esriModule.projection.project(geometry, outSpatialReference);
        return newGeo;
      });
    }
  }
}

/**
 * @author: wyt
 * @description:绘制canvas(数据库返回的数据) Attribute
 * @param {*} layerId 图层Id
 * @param {*} canvas 临时canvas
 * @param {*} layerInfo 当前图层Id数据
 * @param {*} data 数据
 * @param {*} realCanvas 真实canvas
 * @param {*} drawType 绘制类型：export 导出大图数据类型
 */
async function drawData_Changed(
  layerId,
  canvas,
  layerInfo,
  data,
  realCanvas,
  drawType
) {
  if (!isInScale(layerId)) {
    await stopDrawText();
    return;
  } else {
    startDrawText();
  }

  var cacheContext = "";
  var cacheCanvas = "";
  var esriModule = store.state.esriModule;
  //用于拾取
  if (!drawType) {
    cacheCanvas = document.createElement("canvas");
    cacheCanvas.className = "gispaiLayer";
    cacheCanvas.setAttribute("id", layerId + "_changedTemp");
    cacheCanvas.width = realCanvas.width;
    cacheCanvas.height = realCanvas.height;
    cacheCanvas.style.left = "0px";
    cacheCanvas.style.top = "0px";
    cacheCanvas.style.position = "absolute";
    cacheContext = cacheCanvas.getContext("2d");
  }
  var tmp = ChangedCanvasCache.findIndex((ele) => {
    return ele.layerId == layerId;
  });

  if (tmp === -1) {
    var obj = {
      layerId: layerId,
      geoType: layerInfo.GeoType,
      cacheContext: cacheContext,
      cacheCanvas: cacheCanvas, //,
      //data: data
    };
    ChangedCanvasCache.push(obj);
  }
  let context = "";
  if (canvas) {
    context = canvas.getContext("2d");
  }

  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
  var isRender = false;
  let layerSym = symbol;
  //判断是否有字段
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  var style = {};
  if (!isRender) {
    style = getCanvasStyle(layerInfo, "", symbol);
    if (layerInfo.GeoType === "线") {
      if (style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async (val) => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          await commonB.drawData_Changed_noRenderDraw(
            layerId,
            canvas,
            layerInfo,
            data,
            val,
            context,
            cacheContext,
            esriModule,
            realCanvas,
            cacheCanvas,
            drawType
          );
        });
      } else {
        for (let key in style.style) {
          context[key] = style.style[key];
        }
        await commonB.drawData_Changed_noRenderDraw(
          layerId,
          canvas,
          layerInfo,
          data,
          style,
          context,
          cacheContext,
          esriModule,
          realCanvas,
          cacheCanvas,
          drawType
        );
      }
    } else if (layerInfo.GeoType === "面") {
      if (style.set.lineStyles && style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async (val) => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          commonB.drawData_Changed_noRenderDraw(
            layerId,
            canvas,
            layerInfo,
            data,
            val,
            context,
            cacheContext,
            esriModule,
            realCanvas,
            cacheCanvas,
            drawType
          );
        });
      } else {
        for (let key in style.style) {
          context[key] = style.style[key];
        }
        commonB.drawData_Changed_noRenderDraw(
          layerId,
          canvas,
          layerInfo,
          data,
          style,
          context,
          cacheContext,
          esriModule,
          realCanvas,
          cacheCanvas,
          drawType
        );
      }
    } else {
      for (let key in style.style) {
        context[key] = style.style[key];
      }
      commonB.drawData_Changed_noRenderDraw(
        layerId,
        canvas,
        layerInfo,
        data,
        style,
        context,
        cacheContext,
        esriModule,
        realCanvas,
        cacheCanvas,
        drawType
      );
    }
  } else {
    commonB
      .getUniRenderLabelVals(layerId, data, layerSym.FieldName, "Attribute")
      .then(async (res) => {
        var keys = Object.keys(res);
        commonB.drawData_Changed_noRenderDraw(
          layerId,
          canvas,
          layerInfo,
          data,
          style,
          context,
          cacheContext,
          esriModule,
          realCanvas,
          cacheCanvas,
          drawType,
          keys,
          res,
          symbol
        );
      });
  }
  stopDrawText();
}

// 开始绘图文字
function startDrawText() {
  // store.dispatch("setDrawingText", "正在绘制...");
  //监听图层显隐
  // var draVal = store.state.dragParams;
  // store.dispatch("zoomEndTimestamp", draVal.firstTimestamp);
}

/**
 * @author: wyt
 * @description: 获取canvas的符号样式
 * @param {*} layerInfo 图层数据
 * @param {*} attrIndex  属性index
 * @return {*}
 */
function getCanvasStyle(layerInfo, attrIndex, symbol) {
  var style = {};
  if (layerInfo.RenderType == "SimpleRender") {
    var newSys = symbol.Symbol;
    if (layerInfo.GeoType == "面") {
      style = getPolygonStyle(newSys, symbol.SymbolType);
    } else if (layerInfo.GeoType == "线") {
      style = getPolylineStyle(newSys);
    } else {
      style = getPointStyle(newSys, symbol.SymbolType);
    }
  } else {
    var isMap = getPageType() == 1 ? true : false;
    var allSymbols = symbol.Symbols;
    var newSys;
    if (isMap) {
      newSys = allSymbols[+attrIndex - 1];
    } else {
      var index = -1;
      if (layerInfo.RenderType == "UniqueRender") {
        index = allSymbols.findIndex((ele) => ele.Value == attrIndex);
      } else {
        if (attrIndex == "") {
          index = -1;
        } else {
          index = allSymbols.findIndex((ele) => {
            let arr = ele.Value.split("-");
            return (
              parseFloat(attrIndex) > parseFloat(arr[0]) &&
              parseFloat(attrIndex) <= parseFloat(arr[1])
            );
          });
        }
      }
      if (index > -1) {
        newSys = allSymbols[index];
      } else {
        newSys = allSymbols[0];
      }
    }
    if (newSys) {
      if (layerInfo.GeoType === "面") {
        style = getPolygonStyle(newSys.Symbol, newSys.SymbolsType);
      } else if (layerInfo.GeoType === "线") {
        style = getPolylineStyle(newSys.Symbol);
      } else {
        style = getPointStyle(newSys.Symbol, newSys.SymbolsType);
      }
    }
  }

  return style;
}

/**
 * @author: wyt
 * @description: 线符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
function getPolylineStyle(newSys, symbolType) {
  var style = {};
  var scolorStr =
    newSys.color.r +
    "," +
    newSys.color.g +
    "," +
    newSys.color.b +
    "," +
    newSys.color.a;
  var styles = [];
  if (newSys.lineStyles && newSys.lineStyles.length) {
    newSys.lineStyles.forEach((val) => {
      // 查找缓存图片
      var index = store.state.layerImages.findIndex(
        (item) => item.url === val.imgUrl
      );
      var fillImg = "";
      if (index > -1) {
        fillImg = store.state.layerImages[index].image;
      }

      var param = {
        style: {
          lineWidth: val.borderWidth,
          strokeStyle: val.borderColor,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu,
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          spaceList: val.spaceList && val.spaceList.length ? val.spaceList : [],
          symobolType: val.type,
          space: val.space,
          unicode:
            val.type === "Simple" && val.unicode
              ? eval(
                  '("' +
                    `${val.unicode}`.replace("&#x", "\\u").replace(";", "") +
                    '")'
                )
              : "",
          // unicode: val.type === "Simple" && val.unicode ? val.unicode : "",
          angle: val.angle,

          url:
            val.type === "Picture" && val.imgUrl
              ? myConfig.baseUrl + val.imgUrl
              : "",
          color: val.fillColor,
          offsetX: val.offsetX,
          offsetY: val.offsetY,
          size: val.size,
          height: val.imgheight,
          width: val.imgwidth,
          lineDirection: val.lineDirection,
          image: fillImg,
        },
        angle: val.angle,
      };
      styles.push(param);
    });
  }
  style = {
    style: {
      strokeStyle: "rgba(" + scolorStr + ")",
      lineWidth: newSys.width,
    },
    set: {
      lineDash: newSys.style == "solid" ? [] : [5, 5],
      lineStyles: styles,
    },
  };
  return style;
}

//根据三点形成的弧或圆返回所有个点集
function setArcline(tmp, type) {
  let obj = locate(tmp);
  if (type == "circle") {
    let list = [];
    let steps = 360;
    let ct = trufPoint([obj.x, obj.y]);
    //ct = toMercator(ct)
    let center = {
      x: ct.geometry.coordinates[0],
      y: ct.geometry.coordinates[1],
    };
    let radius = obj.radius;

    let alfa = 360;
    let i = 0;
    while (alfa >= 0) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = 360 - (i * 360) / steps;
    }
    // if (alfa > 360) {
    //   let pt = getArcPt(center, radius, 360);
    //   list.push(pt);
    // }
    return list;
  } else {
    let list = DrawArcFromThreePoint(obj);
    return list;
  }
}

function locate(datas) {
  let x1, x2, x3, y1, y2, y3;
  let point1 = datas[0];
  let point2 = datas[1];
  let point3 = datas[2];

  if (point1.x == point3.x && point1.y == point3.y) {
    let x0 = (point1.x + point2.x) / 2;
    let y0 = (point1.y + point2.y) / 2;
    let radius = Math.sqrt(
      (point1.x - x0) * (point1.x - x0) + (point1.y - y0) * (point1.y - y0)
    );
    var angle3 = GetAngle(point2.x - x0, point2.y - y0); //中间点
    let line = lineString([
      [point1.x, point1.y],
      [x0, y0],
    ]);
    let dis = truflength(line, {
      units: "kilometers",
    });

    var obj = {
      x: x0,
      y: y0,
      angle1: 0,
      angle2: angle3,
      radius: radius,
      angle3: 360,
      radius1: dis,
    };
    return obj;
  } else {
    x1 = point1.x;
    y1 = point1.y;
    x2 = point2.x;
    y2 = point2.y;
    x3 = point3.x;
    y3 = point3.y;

    let a1 = x1 - x2;
    let b1 = y1 - y2;
    let c1 = x1 - x3;
    let d = y1 - y3;
    let e = (x1 * x1 - x2 * x2 + (y1 * y1 - y2 * y2)) / 2.0;
    let f = (x1 * x1 - x3 * x3 + (y1 * y1 - y3 * y3)) / 2.0;
    let det = b1 * c1 - a1 * d;
    // if (Math.abs(det) > 0.000001) {
    let x0 = -(d * e - b1 * f) / det;
    let y0 = -(a1 * f - c1 * e) / det;

    let pt = trufPoint([x0, y0]);
    // if (coordinate != 102100) {
    //   pt = toWgs84(pt)
    // }
    var radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    //   if (coordinate != 102100) {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //     //radius = radius / 111000
    //   } else {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //   }
    var angle1 = GetAngle(x1 - x0, y1 - y0);
    var angle2 = GetAngle(x3 - x0, y3 - y0);
    var angle3 = GetAngle(x2 - x0, y2 - y0); //中间点
    let line = lineString([
      [x1, y1],
      [x0, y0],
    ]);
    let dis = truflength(line, {
      units: "kilometers",
    });
    var obj = {
      x: pt.geometry.coordinates[0],
      y: pt.geometry.coordinates[1],
      angle1: angle1,
      angle2: angle3,
      radius: radius,
      angle3: angle2,
      radius1: dis,
    };
    return obj;
    // }
  }
}

function GetAngle(x, y) {
  if (x > 0 && y == 0) {
    return 0;
  } else if (x > 0 && y > 0) {
    return (Math.atan(y / x) * 180) / Math.PI;
  } else if (x == 0 && y > 0) {
    return 90;
  } else if (x < 0 && y > 0) {
    return 180 - (Math.atan(y / -x) * 180) / Math.PI;
  } else if (x < 0 && y == 0) {
    return 180;
  } else if (x < 0 && y < 0) {
    return 180 + (Math.atan(y / x) * 180) / Math.PI;
  } else if (x == 0 && y < 0) {
    return 270;
  } else if (x > 0 && y < 0) {
    return 360 - (Math.atan(-y / x) * 180) / Math.PI;
  }
}

//三点绘弧线
function DrawArcFromThreePoint(obj) {
  let list = [];
  let steps = 360;

  var radius = obj.radius;
  var fangle = obj.angle1; //第一点角度
  var sangle = obj.angle2; //第二点角度
  var tangle = obj.angle3; //第三点角度
  let ct = trufPoint([obj.x, obj.y]);
  //ct = toMercator(ct)
  let center = {
    x: ct.geometry.coordinates[0],
    y: ct.geometry.coordinates[1],
  };
  if (fangle > tangle && fangle > sangle && sangle > tangle) {
    //fangle一直减到tangle
    let i = 0;
    let alfa = fangle;
    while (alfa > tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle - (i * 360) / steps;
    }
    if (alfa < tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle > tangle && (fangle < sangle || sangle < tangle)) {
    //fangle一直加到360，再从0加到tangle
    tangle = tangle + 360;
    let alfa = fangle;
    let i = 0;
    while (alfa < tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle + (i * 360) / steps;
    }
    if (alfa > tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle < tangle && sangle > fangle && sangle < tangle) {
    //fangle一直加到tangle
    let alfa = fangle;
    let i = 0;
    while (alfa < tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle + (i * 360) / steps;
    }
    if (alfa > tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle < tangle && (sangle < fangle || sangle > tangle)) {
    //fangle一直减到0，再从360减到tangle
    let i = 0;
    let alfa = fangle;
    while (alfa > 0) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle - (i * 360) / steps;
    }
    let j = 0;
    let alfa2 = 360;
    while (alfa2 > tangle) {
      let pt = getArcPt(center, radius, alfa2);
      list.push(pt);
      j++;
      alfa2 = 360 - (j * 360) / steps;
    }
    if (alfa2 < tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  }
  return list;
}

function getArcPt(center, radius, alfa) {
  //radius = radius / 111000
  let x = center.x + radius * Math.cos(((Math.PI * 2) / 360) * alfa);
  let y = center.y + radius * Math.sin(((Math.PI * 2) / 360) * alfa);
  let p = trufPoint([x, y]);
  //   if (coordinate != 102100) {
  //     p = toWgs84(p)
  //   }
  return [p.geometry.coordinates[0], p.geometry.coordinates[1]];
}

/**
 * @author: wyt
 * @description: 面符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
function getPolygonStyle(newSys, symbolType) {
  var style = {};
  var styles = getStyles(newSys);
  if (symbolType == "Simple") {
    var fcolorStr =
      newSys.color.r +
      "," +
      newSys.color.g +
      "," +
      newSys.color.b +
      "," +
      newSys.color.a;
    var scolorStr = newSys.outline
      ? newSys.outline.color.r +
        "," +
        newSys.outline.color.g +
        "," +
        newSys.outline.color.b +
        "," +
        newSys.outline.color.a
      : fcolorStr;

    style = {
      style: {
        fillStyle: "rgba(" + fcolorStr + ")",
        strokeStyle: "rgba(" + scolorStr + ")",
        lineWidth: newSys.outline ? newSys.outline.width : 0,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
      set: {
        lineDash: newSys.outline
          ? newSys.outline.style == "solid"
            ? []
            : [5, 5]
          : [],
        lineStyles: styles,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
    };
  } else {
    var scolorStr = newSys.outline
      ? newSys.outline.color.r +
        "," +
        newSys.outline.color.g +
        "," +
        newSys.outline.color.b +
        "," +
        newSys.outline.color.a
      : 0;
    var imageUrl = newSys.url;
    // 查找缓存图片
    var index = store.state.layerImages.findIndex(
      (item) => item.url === imageUrl
    );
    var fillImg = "";
    if (index > -1) {
      fillImg = store.state.layerImages[index].image;
    }
    style = {
      style: {
        strokeStyle: "rgba(" + scolorStr + ")",
        lineWidth: newSys.outline ? newSys.outline.width : 0,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
      set: {
        lineDash: newSys.outline
          ? newSys.outline.style == "solid"
            ? []
            : [5, 5]
          : [],
        url: commonB.getImgPathUrl() + imageUrl,
        height: newSys.height,
        width: newSys.width,
        image: fillImg,
        lineStyles: styles,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
    };
  }
  return style;
}

/**
 * 获取样式
 * @param {*} newSys
 * @returns
 */
function getStyles(newSys) {
  var styles = [];
  if (newSys.lineStyles && newSys.lineStyles.length) {
    newSys.lineStyles.forEach((val) => {
      var imageUrl = val.ployImage ? val.ployImage : val.imgUrl;
      var index = store.state.layerImages.findIndex(
        (item) => item.url === imageUrl
      );
      var param = {
        style: {
          fillStyle: imageUrl ? "" : val.fillColor,
          strokeStyle: val.borderWidth ? val.borderColor : "rbga(0)",
          lineWidth: val.borderWidth,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu,
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          url: imageUrl ? commonB.getImgPathUrl() + imageUrl : "",
          height: val.size + val.space,
          width: val.size + val.space,
          image: index > -1 ? store.state.layerImages[index].image : "",
          bgroundColor: "rgba(0,0,0,0)",
        },
      };
      styles.push(param);
    });
    if (
      newSys.lineStyles[0].backgroundColor &&
      newSys.lineStyles[0].backgroundColor != "rgba(0,0,0,0)"
    ) {
      var val = newSys.lineStyles[0];
      var imageUrl = val.ployImage ? val.ployImage : val.imgUrl;
      var index = store.state.layerImages.findIndex(
        (item) => item.url === imageUrl
      );
      var param = {
        style: {
          fillStyle: imageUrl ? "" : val.fillColor,
          strokeStyle: val.borderColor,
          lineWidth: val.borderWidth,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu,
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          url: imageUrl ? commonB.getImgPathUrl() + imageUrl : "",
          height: val.size + val.space,
          width: val.size + val.space,
          image: index > -1 ? store.state.layerImages[index].image : "",
          bgroundColor: val.backgroundColor,
        },
      };
      styles.unshift(param);
    }
  }
  return styles;
}

//清除有关弧线的相关信息
function clearArcLineArr(layerId, Id, type) {
  // let arcLineArr = store.state.arcLineArr;
  // if (type == "all") {
  //   store.commit("set_arcLineArr", []);
  // } else if (type == "layer") {
  //   let temp = [];
  //   for (let i = 0; i < arcLineArr.length; i++) {
  //     if (arcLineArr[i].layerId != layerId) {
  //       temp.push(arcLineArr[i]);
  //     }
  //   }
  //   store.commit("set_arcLineArr", temp);
  // } else {
  //   let index = arcLineArr.findIndex(
  //     (x) => x.layerId == layerId && x.featureId == Id
  //   );
  //   if (index != -1 && index != undefined) {
  //     arcLineArr.splice(index, 1);
  //   }
  //   store.commit("set_arcLineArr", arcLineArr);
  // }
}

/**
 * @author: jfx
 * @description:地图拖拽完成事件
 * @export
 * @param {*} lastExtent 前一次地图范围
 * @param {*} nowExtent 当前地图范围
 * @param {*} firstDragTimestamp 时间戳
 */
async function dragChange(lastExtent, nowExtent, firstDragTimestamp) {
  ZHT_curtentExtent = nowExtent;
  ZHT_LabelDrawData = [];
  store.dispatch("setBaseLayerDraging", false);
  //添加或更新无级放大底图
  // commonB.addBaseLayerToCanvas();
  totalPostCounts = 0;
  hasPostedCounts = 0;

  //所有图层请求次数
  allTotalLayerPost = 0;
  allTotalLayerHasPosted = 0;
  //取消上次请求未完成的请求
  clearCancleToken();

  // var layerNodes = getVetorLayerNode(store.state.dataTreeData);
  // if (layerNodes.length > 0 && !commonB.isAllLayerClose()) {
  startDrawText();
  // }

  //高亮层的canvas增减，超出的减去，新范围增加
  createCanvas("highlight", "drag");
  //高亮层中继续保留的canvas偏移
  resetPickedCanvasByDrag("highlight");
  commonB.resetPointPickedCanvasByDrag("highlight");
  //选择层增减，超出的减去，新范围增加
  // createCanvas("selected", "drag");
  //选择层中继续保留的canvas偏移
  // resetPickedCanvasByDrag("selected");
  // commonB.resetPointPickedCanvasByDrag("selected");
  selectedAllData = selectedAllData.filter(
    (ele) => ele.type != "vector" && ele.type == "screen" && ele.geoType != "点"
  );

  var lastrowcol = getRowCol(lastExtent);
  var rowcol = getRowCol(nowExtent);
  var nowoffset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
  nowOffsetX = nowoffset.offsetX;
  nowOffsetY = nowoffset.offsetY;

  //清空数据库canvas数据
  ChangedCanvasCache = [];
  //移除范围外的切片数据缓存
  TileData = TileData.filter(
    (x) =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  );
  //移除范围外的切片缓存缓存
  TileCanvasCache = TileCanvasCache.filter(
    (x) =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  );

  labelData = labelData.filter((x) => x.type == "Vector");

  //移除不在当前范围的未绘制的行列
  hasnotDrawRowCol = hasnotDrawRowCol.filter(
    (x) =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  );

  //移除不在当前范围的切片canvas
  var ctnelement = document.getElementsByClassName("gispaiLayer");
  if (ctnelement && ctnelement.length > 0) {
    var ele = ctnelement;
    for (var k = 0; k < ele.length; k++) {
      if (ele[k].id.indexOf("changed") == -1) {
        var ids = ele[k].id.split("_");
        var eLayerId = +ids[0];
        var eRow = +ids[1];
        var eCol = +ids[2];
        //不在当前范围的行列移除
        if (
          eRow < rowcol.minRow ||
          eRow > rowcol.maxRow ||
          eCol < rowcol.minCol ||
          eCol > rowcol.maxCol
        ) {
          ele[k].remove();
          k = k - 1;
        } else if (
          eRow >= rowcol.minRow &&
          eRow <= rowcol.maxRow &&
          eCol >= rowcol.minCol &&
          eCol <= rowcol.maxCol
        ) {
          //在当前范围行列
          //全局数据在当前范围的行列要做偏移
          var offset = getCoordByRowCol(eRow, eCol);
          TileData.map((item) => {
            if (
              item.layerId == eLayerId &&
              item.row == eRow &&
              item.col == eCol
            ) {
              item.offset = offset;
            }
            return item;
          });
        }
      }
    }
  }

  //当前范围新增的行列号,加入到未绘制行列
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      if (!store.state.stopLoading) {
        if (
          i < lastrowcol.minRow ||
          i > lastrowcol.maxRow ||
          j < lastrowcol.minCol ||
          j > lastrowcol.maxCol
        ) {
          hasnotDrawRowCol.push({
            row: i,
            col: j,
          });
        }
      }
    }
  }

  //去重
  hasnotDrawRowCol = _.uniqWith(hasnotDrawRowCol, _.isEqual);

  selectedAllData = selectedAllData.filter((x) =>
    x.data.filter(
      (y) =>
        y.row >= rowcol.minRow &&
        y.row <= rowcol.maxRow &&
        y.col >= rowcol.minCol &&
        y.col <= rowcol.maxCol
    )
  );

  var type = store.state.pageType == "data" ? 1 : 2;
  var val = store.state.SingleData;
  for (var i = 0; i < allLayerInfoList.length; i++) {
    var layerId = allLayerInfoList[i].Id;
    var layerInfo = allLayerInfoList.find((val) => val.Id == layerId);
    //显隐
    if (!isInScale(layerId)) {
      continue;
    }

    //标记这个图层数据已加载
    layerInfo.hasLoadData = true;
    //判断图层数据按切片加载还是按原始数据全部加载模式
    if (!layerInfo.IsTileMode) {
      getAllDataFromServer(layerId, "drag");
    } else {
      //拖拽完成操作
      ProcessAfterDrag(
        allLayerInfoList[i],
        firstDragTimestamp,
        lastExtent,
        nowExtent,
        hasnotDrawRowCol
      );
    }
  }
}

// 取消请求
function clearCancleToken() {
  if (cancleToken.length > 0) {
    cancleToken.forEach((ele) => {
      ele.cancel("取消请求");
    });
    cancleToken = [];
  }
}

/**
 * @author: wyt
 * @description:创建canvas
 * @param {*} name 类名后缀(Selected或highlight)
 * @param {*} mouseType 操作类型（drag、scale等）
 */
function createCanvas(name, mouseType, dataType) {
  var div = document.querySelector("#mapView_gc");
  if (div == null) return;
  var canvasCtn = document.querySelector(".gispaiLayer_" + name);
  if (!canvasCtn) {
    canvasCtn = document.createElement("div");
    canvasCtn.className = "gispaiLayer_" + name + " gsplayer";
    canvasCtn.style.position = "absolute";
    div.before(canvasCtn);
  } else {
    if (mouseType == "drag") {
      //删除数据库数据对应的canvas
      var ele1 = document.getElementById(name + "_point_changed");
      var ele2 = document.getElementById(name + "_changed");
      if (ele1) ele1.remove();
      if (ele2) ele2.remove();
    } else if (mouseType != "selectedTool") {
      canvasCtn.innerHTML = "";
    }
  }
  //行列canvas
  var rowcol = getRowCol(map.extent);
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      var offset = getCoordByRowCol(i, j);
      var ele = document.getElementById(name + "_" + i + "_" + j);
      if (!ele) {
        ele = document.createElement("canvas");
        ele.className = name + "Layer";
        ele.style.left = offset.offsetX + "px";
        ele.style.top = offset.offsetY + "px";
        ele.setAttribute("id", name + "_" + i + "_" + j);
        ele.width = 256;
        ele.height = 256;
        ele.style.position = "absolute";
        canvasCtn.append(ele);
      }
      var pointEle = document.getElementById(
        name + "_" + i + "_" + j + "_point"
      );
      if (!pointEle) {
        pointEle = document.createElement("canvas");
        pointEle.className = name + "Layer";
        pointEle.style.left = offset.offsetX - pointSpace + "px";
        pointEle.style.top = offset.offsetY - pointSpace + "px";
        pointEle.setAttribute("id", name + "_" + i + "_" + j + "_point");
        pointEle.width = pointCanvasWidth;
        pointEle.height = pointCanvasWidth;
        pointEle.style.position = "absolute";
        canvasCtn.append(pointEle);
      }
      var lineEle = document.getElementById(name + "_" + i + "_" + j + "_line");
      if (!lineEle) {
        lineEle = document.createElement("canvas");
        lineEle.className = name + "Layer";
        lineEle.style.left = offset.offsetX - pointSpace + "px";
        lineEle.style.top = offset.offsetY - pointSpace + "px";
        lineEle.setAttribute("id", name + "_" + i + "_" + j + "_line");
        lineEle.width = pointCanvasWidth;
        lineEle.height = pointCanvasWidth;
        lineEle.style.position = "absolute";
        canvasCtn.append(lineEle);
      }
    }
  }

  //全地图canvas
  var canvas = document.getElementById(name + "_changed");
  if (!canvas) {
    canvas = document.createElement("canvas");
    var pdiv = document.querySelector("#mapView");
    canvas.id = name + "_changed";
    canvas.className = name + "Layer" + " changedCanvas";
    canvas.width = pdiv.clientWidth;
    canvas.height = pdiv.clientHeight;
    canvas.style.position = "absolute";
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    canvasCtn.append(canvas);
  }

  // //点canvas
  // var pcanvas = document.getElementById(name + "_point_changed");
  // if (!pcanvas) {
  //   var rowcol = getRowCol(map.extent);
  //   // createPointCanvas(canvasCtn, rowcol, name, name);
  // }
}

/**
 * @author: wyt
 * @description: 根据extent计算行列号 最大行列和最小行列 左下角最小
 * @export
 * @param {*} extent 范围
 * @return {*}
 */
function getRowCol(extent) {
  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }

  var res = map.__tileInfo.lods[level].resolution;
  var minrow = Math.floor((extent.ymin - OriginY) / (res * 256));
  var maxrow = Math.floor((extent.ymax - OriginY) / (res * 256));
  var mincol = Math.floor((extent.xmin - OriginX) / (res * 256));
  var maxcol = Math.floor((extent.xmax - OriginX) / (res * 256));
  return {
    minRow: minrow,
    maxRow: maxrow,
    minCol: mincol,
    maxCol: maxcol,
  };
}

/**
 * @author: wyt
 * @description: 计算某行某列偏移
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @return {*}
 */
function getCoordByRowCol(row, col) {
  var esriModule = store.state.esriModule;
  var level = map.getLevel();
  // 原点
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;

  var extent = map.extent;

  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  // 地图分辨率
  var res = map.__tileInfo.lods[level].resolution;
  // 计算出当前分辨率行列的起始点
  var x = col * res * 256 + OriginX;
  var y = (row + 1) * res * 256 + OriginY;

  //像素偏移量的xy
  var offsetX = (extent.xmin - x) / res;
  var offsetY = (extent.ymin - y) / res;

  var point = new esriModule.Point(
    extent.xmin,
    extent.ymin,
    map.spatialReference
  );
  var screenPoint = map.toScreen(point);
  // 像素偏移量
  return {
    offsetX: screenPoint.x - offsetX,
    offsetY: screenPoint.y + offsetY,
  };
}

/**
 * canvas偏移操作,  移除超出canvas和修改还在屏幕内canvas的偏移量
 * @param {*} name 类名
 */
function resetPickedCanvasByDrag(name) {
  var rowcol = getRowCol(map.extent);
  var ctnelement = document.getElementsByClassName(name + "Layer");
  // setLayerClass(ctnelement, rowcol);
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      var offset = getCoordByRowCol(i, j);
      var index = TileCanvasCache.findIndex((ele) => {
        return ele.row == i && ele.col == j;
      });
      if (index > -1) {
        TileCanvasCache[index].cacheCanvas.style.left = offset.offsetX + "px";
        TileCanvasCache[index].cacheCanvas.style.top = offset.offsetY + "px";
      }
    }
  }
}

// 移除超出canvas和修改还在屏幕内canvas的偏移量
function setLayerClass(ctnelement, rowcol) {
  if (ctnelement && ctnelement.length > 0) {
    var ele = ctnelement;
    for (var k = 0; k < ele.length; k++) {
      if (ele[k].id.indexOf("changed") == -1) {
        var ids = ele[k].id.split("_");
        var eRow = parseInt(ids[1]);
        var eCol = parseInt(ids[2]);
        //超出屏幕范围移除
        if (
          eRow < rowcol.minRow ||
          eRow > rowcol.maxRow ||
          eCol < rowcol.minCol ||
          eCol > rowcol.maxCol
        ) {
          ele[k].remove();
          k = k - 1;
          //删除超出范围的缓存
          var index = TileCanvasCache.findIndex((ele) => {
            return ele.row == eRow && ele.col == eCol;
          });
          if (index > -1) {
            TileCanvasCache.splice(index, 1);
          }
        } else if (
          eRow >= rowcol.minRow &&
          eRow <= rowcol.maxRow &&
          eCol >= rowcol.minCol &&
          eCol <= rowcol.maxCol
        ) {
          var offset = getCoordByRowCol(eRow, eCol);
          ele[k].style.left = offset.offsetX + "px";
          ele[k].style.top = offset.offsetY + "px";
        }
      }
    }
  }
}

/**
 * 更新ChangedData
 * @export
 * @param {*} data 数据库数据
 * @param {*} layerId
 * @return {*}
 */
function updateChangedData(extent, layerId, layerInfo) {
  var singlechangeData = [];
  var currentchangeData = [];
  var changeDataIndex = AllChangedData.findIndex(
    (item) => item.layerId === layerId
  );
  //var currentchangeDataIndex = ChangedData.findIndex(item => item.layerId === layerId);
  var data = [];
  if (changeDataIndex > -1) {
    data = AllChangedData[changeDataIndex].data;
  }
  var tolerance =
    (extent.xmax - extent.xmin + extent.ymax - extent.ymin) / 1000;
  for (let index = 0; index < data.length; index++) {
    // 将数据缓存 在label中使用
    var lisVal = data[index];
    var _data = lisVal;
    let extentArr = _data.Extent.split(",");
    // 获取范围内的数据
    var params = {
      xmin: parseFloat(extentArr[0]),
      ymin: parseFloat(extentArr[1]),
      xmax: parseFloat(extentArr[2]),
      ymax: parseFloat(extentArr[3]),
    };
    if (isInExtent(params, extent, layerInfo, tolerance)) {
      // currentchangeData.push(lisVal)
      lisVal.IsInView = true;
    } else {
      lisVal.IsInView = false;
      lisVal.IsInView = true;
    }
  }
}

/**
 * @author: wyt
 * @description:缩放过程显隐
 * @export
 */
function scaleHandleChange() {
  // var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
  for (var i = 0; i < allLayerInfoList.length; i++) {
    var layerId = allLayerInfoList[i].Id;
    setVisibleByScale(layerId, allLayerInfoList[i]);
  }
}

/**
 * @author: wyt
 * @description:缩放过程显隐设置
 * @export
 * @param {*} layerId 图层Id
 */
function setVisibleByScale(layerId) {
  var layerInfo = allLayerInfoList.filter((val) => {
    return val.Id == layerId;
  });
  setScale(layerId, layerInfo[0]);
}

/**
 * @author: wyt
 * @description:前后2个范围相交的部分,比例
 * @export
 * @param {*} layerId 图层Id
 * @param {*} layerInfo 图层数据
 */
function setScale(layerId, layerInfo) {
  // var nodeData = getVetorLayerNode(store.state.dataTreeData);
  // let node = nodeData.find(ele => ele.id == layerId);
  var ele = document.getElementsByClassName("gispaiLayer_" + layerId);
  var labelEle = document.getElementById("gispaiLayer_labelLayer_" + layerId);
  // let pNode = store.state.dataTreeData[0];
  // let pChecked = pNode.checked;

  //判断是否在图层的当前比例尺内
  var flag = isInScale(layerId);
  // if (pChecked) {
  //   let isShow = getChecked(node, layerInfo);
  //   if (!isShow) {
  //     if (ele.length > 0) {
  //       ele[0].style.display = "none";
  //     }
  //   } else {
  //     if (flag === true) {
  //       if (ele.length > 0) {
  //         ele[0].style.display = "block";
  //       }
  //     } else if (flag === false) {
  //       if (ele.length > 0) {
  //         ele[0].style.display = "none";
  //       }
  //     }
  //   }
  // } else {
  //   if (ele.length > 0) {
  //     ele[0].style.display = "none";
  //   }
  // }

  if (labelEle && ele.length) {
    labelEle.style.display = ele[0].style.display;
  }
  //树形数据中标记不显示的图层
  // var dataTrees = store.state.dataTreeData;
  // commonB.filterDataTrees(dataTrees[0].children, layerId, flag);
  // store.dispatch("setDataTree", dataTrees);
}

/**
 * @author: wyt
 * @description:地图缩放事件
 * @export
 * @param {*} firstTimestamp 时间戳
 */
function extentChange(firstTimestamp) {
  // commonB.addBaseLayerToCanvas("extent")

  store.dispatch("setStopLoading", false);

  clearCancleToken();

  //绘制等待文本效果
  allTotalLayerPost = 0;
  allTotalLayerHasPosted = 0;

  clearArcLineArr(null, null, "all");
  //获取矢量图层
  // var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
  //选择图层canvas
  // createCanvas("selected", "scale");

  //拾取canvas
  createCanvas("highlight", "scale");

  // 点.选择图层
  // if (vectorLayerData.length > 0 && !commonB.isAllLayerClose()) {
  startDrawText();
  // } else {
  //   stopDrawText();
  // }

  //清除存在全局变量中的标注数据
  labelData = [];

  var type = store.state.pageType == "data" ? 1 : 2;
  var val = store.state.SingleData;

  for (var i = allLayerInfoList.length - 1; i >= 0; i--) {
    var layerId = allLayerInfoList[i].Id;
    let layerInfo = allLayerInfoList.find((x) => x.Id == layerId);
    //次数不一样，清除
    if (lastNumber != currentNumber) {
      var canvasCtn = document.getElementsByClassName("gispaiLayer");
      for (let j = 0; j < canvasCtn.length; j++) {
        canvasCtn[j].remove();
        j = j - 1;
      }
      TileCanvasCache = [];
      ChangedCanvasCache = [];
    }

    lastNumber = 0;
    currentNumber = 0;
    //选中的数据
    selectedAllData = selectedAllData.filter((ele) => ele.layerId != layerId);

    //清除label
    clearLabelCanvas(layerId);

    //点label偏移
    labelCanvasoffset(layerId);

    //过滤全局数据
    TileData = TileData.filter((ele) => ele.layerId != layerId);
    //缓存数据
    TileCanvasCache = TileCanvasCache.filter((ele) => ele.layerId != layerId);

    ChangedCanvasCache = ChangedCanvasCache.filter((ele) => {
      return ele.layerId != layerId;
    });
    if (selectedAllData.length > 0) {
      if (current_tool === "movepolygons") {
        // 绘制平移数据
        commonB.createMoveCanvas(selectedAllData);
      }
    }
    //监听缩放
    store.dispatch("zoomEndTimestamp", firstTimestamp);

    //判断当前图层是否可见
    // if (!isShowLayer(layerId, layerInfo)) {
    //   continue;
    // }

    //标记这个图层数据已加载
    layerInfo.hasLoadData = true;

    if (!layerInfo.IsTileMode) {
      getAllDataFromServer(layerId, "scale");
    } else {
      //加载数据库数据
      getChangedData(layerId, "scale", allLayerInfoList[i]).then((res) => {
        //加载行列切片数据
        addTileData(res, "scale", firstTimestamp);
      });
    }
  }
}

/**
 * @author: wyt
 * @description:拖拽过程偏移操作 偏移量
 * @export
 * @param {*} evt 地图evt
 * @param {*} clientX 上一次X值
 * @param {*} clientY 上一下Y值
 */
function handleOffsetEvent(evt, clientX, clientY) {
  var cX = evt.clientX;
  var cY = evt.clientY;

  var OffsetX = cX - clientX;
  var OffsetY = cY - clientY;
  // 平移
  if (current_tool == "movepolygons") {
    var ele = document.getElementsByClassName("moveScreenLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
      unlockClock();
    }
  } else {
    var ele = document.getElementById("sucaiLayerId");
    if (ele) {
      var newLeft = ele.offsetLeft + OffsetX;
      var newTop = ele.offsetTop + OffsetY;
      ele.style.top = newTop + "px";
      ele.style.left = newLeft + "px";
    }

    var ele = document.getElementsByClassName("gsplayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }

    var ele = document.getElementsByClassName("datalayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }

    //label标注
    var labelEle = document.getElementsByClassName("labelLayer");
    if (labelEle && labelEle.length > 0) {
      setCanvasOffset(labelEle, OffsetX, OffsetY);
    }

    // 底图
    var ele = document.getElementsByClassName("baseLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }
  }
}

/**
 * @author: wyt
 * @description:canvas偏移设置
 * @param {*} ele canvas元素
 * @param {*} offsetX  x偏移值
 * @param {*} offsetY  y偏移值
 */
function setCanvasOffset(ele, offsetX, offsetY) {
  for (var i = 0; i < ele.length; i++) {
    var newLeft = ele[i].offsetLeft + offsetX;
    var newTop = ele[i].offsetTop + offsetY;
    ele[i].style.top = newTop + "px";
    ele[i].style.left = newLeft + "px";
  }
}

// DTPLabel
function clearLabelCanvas(layerId) {
  var canvas = document.getElementById("labelLayer_" + layerId);
  if (canvas) {
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
}

/**
 * 拖拽处理label数据
 * @param {*} layerId
 * @param {*} data
 * @param {*} type
 */
function appendLabelData(layerId, data, type) {
  return new Promise((resolve, reject) => {
    if (data == null || data.length == 0) {
      return;
    }
    var esriModule = store.state.esriModule;
    // var alllayers = store.state.allLayerData;
    let layer = allLayerInfoList.find((x) => x.Id == layerId);
    if (layer.Label) {
      let labels = JSON.parse(layer.Label);
      if (!labels.Visiable) {
        return;
      }
    } else {
      return;
    }
    var labelObj = labelData.filter((x) => x.layerId === layerId);
    let labelIds = [];
    if (labelObj.length > 0) {
      // labelObj.forEach(item => {
      //   labelIds.push(item.ID)
      // })
      for (let index = 0; index < labelObj.length; index++) {
        var item = labelObj[index];
        labelIds.push(item.ID);
      }
    }
    var label;
    if (layer != undefined) {
      if (layer.Label != "" && layer.Label != "") {
        let labelO = JSON.parse(layer.Label);
        label = labelO.LabelField;
      }
    }
    // if (!label) {
    //   // throw new Error("GetFiledValueByIDs tagname 为空!");
    //   return;
    // }
    if (type == "Attribute") {
      commonB
        .getRenderLabelVals(layerId, data, label, "Attribute", 2)
        .then((res) => {
          var keys = Object.keys(res);
          if (data != null) {
            for (let i = 0; i < data.length; i++) {
              var item = data[i];
              var index = keys.findIndex((key) => key === item.Attr.ID + "");
              let labelVal = res[keys[index]];
              if (layer.GeoType == "点") {
                if (labelIds.indexOf(item.Attr.ID) == -1) {
                  let orpt = new esriModule.Point(
                    Number(item.Shape[0][0][0]),
                    Number(item.Shape[0][0][1]),
                    map.spatialReference
                  );
                  //pts = convertLngLat(obj.coordinate, orpt),
                  let pt = map.toScreen(orpt);
                  this.pushLabelData(
                    layerId,
                    item.Attr.ID,
                    pt.x,
                    pt.y,
                    labelVal,
                    type
                  );
                }
              } else {
                if (labelVal) {
                  let o = labelVal.split(";");
                  let position = o[1].split(",");
                  if (labelIds.indexOf(item.Attr.ID) == -1) {
                    let orpt = new esriModule.Point(
                      Number(position[0]),
                      Number(position[1]),
                      map.spatialReference
                    );
                    this.pushLabelData(
                      layerId,
                      item.Attr.ID,
                      orpt.x,
                      orpt.y,
                      o[0],
                      type
                    );
                  }
                }
              }
            }
            resolve(labelData);
          }
        });
    } else {
      commonB
        .getRenderLabelVals(layerId, data, label, "Vector", 2)
        .then((res) => {
          var keys = Object.keys(res);
          for (let i = 0; i < data.length; i++) {
            var item = data[i];
            var index = keys.findIndex((key) => +key === item.O);
            var labelVal = res[keys[index]];
            if (labelVal) {
              if (layer.GeoType == "点") {
                if (labelIds.indexOf(item.O) === -1) {
                  this.pushLabelData(
                    layerId,
                    item.O,
                    0,
                    0,
                    labelVal,
                    type,
                    item.G[0][0][0],
                    item.G[0][0][1]
                  );
                }
              } else {
                let o = labelVal.split(";");
                let position = o[1].split(",");
                if (labelIds.indexOf(item.O) === -1) {
                  let orpt = new esriModule.Point(
                    Number(position[0]),
                    Number(position[1]),
                    map.spatialReference
                  );

                  let pt = map.toScreen(orpt);
                  //this.pushLabelData(layerId, item.O, orpt.x, orpt.y, o[0], type);
                  this.pushLabelData(
                    layerId,
                    item.O,
                    0,
                    0,
                    o[0],
                    type,
                    pt.x,
                    pt.y
                  );
                }
              }
            }
          }
          resolve(labelData);
        });
    }
  });
}

/**
 * label图层偏移
 * @param {*} layerId 图层Id
 */
function labelCanvasoffset(layerId) {
  var layerInfo = allLayerInfoList.find((x) => x.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var rowcol = getRowCol(map.extent);
  var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
  //?
  var canvas = document.getElementById("labelLayer_" + layerId);
  if (canvas) {
    if (layerInfo.GeoType == "点") {
      //点画布
      canvas.style.left = offset.offsetX + "px";
      canvas.style.top = offset.offsetY + "px";
    } else {
      canvas.style.left = "0px";
      canvas.style.top = "0px";
    }
  }
}

/**
 * 绘制图层标注，按数据库数据绘制和切片数据绘制,并将标注添加到LabelData
 * @param {*} layerId
 * @param {*} data
 * @param {*} type 数据类型：数据库数据Attribute，切片数据Vector
 * @param {*} flag 鼠标类型：拖拽，缩放
 * @returns
 */
function DrawLayerLabel(layerId, data, type, flag) {
  var layerIDIndex = notDrawIDs.findIndex((val) => val.layerId == layerId);
  let willDrawData = []; //将要绘制的数据

  //只绘制部分要素图形标注
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  if (
    layerInfo != null &&
    layerInfo.VisibleIDs != null &&
    layerInfo.VisibleIDs.length > 0
  ) {
    for (var m = 0; m < data.length; m++) {
      //只添加要显示的数据
      if (layerInfo.VisibleIDs.indexOf(data[m].ID) >= 0) {
        willDrawData.push(data[m]);
      }
    }
  } else {
    //剔除已删除数据
    for (var m = 0; m < data.length; m++) {
      if (
        layerIDIndex > -1 &&
        notDrawIDs[layerIDIndex].IDs.indexOf(data[m].ID) >= 0
      )
        continue;
      willDrawData.push(data[m]);
    }
  }

  var esriModule = store.state.esriModule;
  // let alllayers = store.state.allLayerData;
  let obj = allLayerInfoList.find((x) => x.Id === layerId);
  if (obj == undefined || obj.Label == "") {
    return;
  }
  let isScale = isInScale(layerId);
  if (!isScale) {
    return;
  }
  let labels = JSON.parse(obj.Label);
  if (!labels.Visiable) {
    return;
  }
  var label = labels.LabelField;

  // 标注存入到labelData里面
  var labelObj = labelData.filter((x) => x.layerId === layerId);
  let labelIds = [];
  if (labelObj.length > 0) {
    labelObj.forEach((item) => {
      labelIds.push(item.ID);
    });
  }
  //数据存储
  let list = [];
  //数据库数据
  if (type == "Attribute") {
    if (obj != undefined) {
      if (obj.Label != "" && obj.Label != null) {
        let labelO = JSON.parse(obj.Label);
        label = labelO.LabelField;
      }
    }

    if (willDrawData != null) {
      commonB
        .getRenderLabelVals(layerId, willDrawData, label, type, 2)
        .then((res) => {
          var keys = Object.keys(res);
          willDrawData.forEach((item) => {
            let index = keys.findIndex((key) => key === item.Attr.ID + ""),
              labelVal = res[keys[index]];
            if (index > -1) {
              if (obj.GeoType === "点") {
                //点的canvas 比较大，减去多出的部分

                item.Shape.forEach((val) => {
                  let orpt = new esriModule.Point(
                      Number(item.Shape[0][0][0]),
                      Number(item.Shape[0][0][1]),
                      map.spatialReference
                    ),
                    //pts = convertLngLat(obj.coordinate, orpt),
                    pt = map.toScreen(orpt),
                    rowcol = getRowCol(map.extent),
                    offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);

                  list.push({
                    x: pt.x - offset.offsetX,
                    y: pt.y - offset.offsetY,
                    label: res[keys[index]],
                  });
                  //存储点在当前地图的地理坐标
                  this.pushLabelData(
                    layerId,
                    item.Attr.ID,
                    orpt.x,
                    orpt.y,
                    res[keys[index]],
                    type
                  );
                });
              } else {
                if (labelVal) {
                  let o = labelVal.split(";"),
                    position = o[1].split(","),
                    orpt = new esriModule.Point(
                      Number(position[0]),
                      Number(position[1]),
                      new esriModule.SpatialReference(obj.coordinate)
                    ),
                    pts = convertLngLat(mapCoordinateNumber, orpt),
                    pt = map.toScreen(pts);
                  list.push({
                    x: pt.x,
                    y: pt.y,
                    label: o[0],
                  });
                  //存储点在当前地图的地理坐标
                  this.pushLabelData(
                    layerId,
                    item.Attr.ID,
                    pts.x,
                    pts.y,
                    o[0],
                    type
                  );
                }
              }
            }
          });
          if (list.length > 0) {
            this.drawLayerLabelOnCanvas(layerId, list, flag, type);
          }
        });
    }
  } else {
    //切片数据
    if (willDrawData != null) {
      commonB
        .getRenderLabelVals(layerId, willDrawData, label, type, 2)
        .then((res) => {
          // console.log(data,'获取后数据')
          // console.log(labelData,'获取后标签数据')
          var keys = Object.keys(res);
          for (var index = 0; index < willDrawData.length; index++) {
            var item = willDrawData[index];
            if (res) {
              let index = keys.findIndex((key) => key === item.O + "");
              let labelVal = res[keys[index]];
              if (index > -1) {
                if (obj.GeoType == "点") {
                  list.push({
                    x: item.G[0][0][0],
                    y: item.G[0][0][1],
                    label: labelVal,
                  });
                  this.pushLabelData(
                    layerId,
                    item.O,
                    0,
                    0,
                    labelVal,
                    type,
                    item.G[0][0][0],
                    item.G[0][0][1]
                  );
                } else {
                  if (labelVal) {
                    let o = labelVal.split(";"),
                      position = o[1].split(","),
                      pts = new esriModule.Point(
                        Number(position[0]),
                        Number(position[1]),
                        map.spatialReference
                      );
                    let pt = map.toScreen(pts);
                    list.push({
                      x: pt.x,
                      y: pt.y,
                      label: o[0],
                    });
                    //this.pushLabelData(layerId, item.O, pts.x, pts.y, o[0], type);
                    this.pushLabelData(
                      layerId,
                      item.O,
                      0,
                      0,
                      o[0],
                      type,
                      pt.x,
                      pt.y
                    );
                  }
                }
              }
            }
          }
          if (list.length > 0) {
            // 初始化的时候边存，边绘制
            this.drawLayerLabelOnCanvas(layerId, list, flag, type);
          }
        });
    }
  }
}

// 【点】相关绘制
/**
 * @author: wyt
 * @description: 点符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
function getPointStyle(newSys, symbolType) {
  var style = {};

  // 查找缓存图片
  var imageUrl = newSys.url;
  var index = store.state.layerImages.findIndex(
    (item) => item.url === imageUrl
  );
  var fillImg = "";
  if (index > -1) {
    fillImg = store.state.layerImages[index].image;
  }
  if (symbolType == "Simple") {
    var fcolorStr =
      newSys.color.r +
      "," +
      newSys.color.g +
      "," +
      newSys.color.b +
      "," +
      newSys.color.a;
    var scolorStr = "";
    if (newSys.outline.color) {
      var scolorStr =
        newSys.outline.color.r +
        "," +
        newSys.outline.color.g +
        "," +
        newSys.outline.color.b +
        "," +
        newSys.outline.color.a;
    }
    if (newSys.unicode) {
      if (newSys.unicode.indexOf("&amp;") !== -1) {
        newSys.unicode = newSys.unicode.replace("&afmp;", "&");
      }
      if (newSys.unicode.indexOf("&amp") !== -1) {
        newSys.unicode = newSys.unicode.replace("&amp", "&");
      }
    }
    style = {
      style: {
        fillStyle: "rgba(" + fcolorStr + ")",
        strokeStyle: "rgba(" + scolorStr + ")",
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
      set: {
        lineDash: newSys.outline.style == "solid" ? [] : [5, 5],
        radius: newSys.size,
        size: newSys.size,
        unicode: eval(
          '("' +
            `${newSys.unicode}`.replace("&#x", "\\u").replace(";", "") +
            '")'
        ),
        color: "rgba(" + fcolorStr + ")",
        offsetX: newSys.offsetX,
        offsetY: newSys.offsetY,
        angle: newSys.angle,
        image: fillImg,
      },
    };
  } else {
    style = {
      style: {
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu,
      },
      set: {
        url: newSys.url ? commonB.getImgPathUrl() + newSys.url : "",
        height: newSys.height,
        width: newSys.width,
        image: fillImg,
      },
    };
  }
  return style;
}

// 限制相关内容
/**
 * @author: wyt
 * @description:判断是否在比例尺内
 * @export
 * @param {*} layerId 图层Id
 * @return {*}
 */
function isInScale(layerId) {
  var layerInfo = allLayerInfoList.find((item) => item.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var scale = map.getScale();
  var maxScale = parseFloat(layerInfo.MaxScale);
  var minScale = parseFloat(layerInfo.MinScale);
  if (minScale != 0 && maxScale != 0) {
    if (scale >= maxScale && scale <= minScale) {
      return true;
    } else {
      return false;
    }
  } else {
    if (minScale == 0 && maxScale == 0) {
      return true;
    } else {
      if (minScale == 0) {
        if (scale >= maxScale) {
          return true;
        } else {
          return false;
        }
      } else {
        if (scale <= minScale) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
}

//判断数据是不是在地图范围内
function isInExtent(dataExtent, extent, layerInfo, tolerance) {
  var cross = false;
  if (layerInfo.GeoType === "点") {
    if (
      dataExtent.xmin > extent.xmin + tolerance &&
      dataExtent.xmin < extent.xmax - tolerance &&
      dataExtent.ymin > extent.ymin + tolerance &&
      dataExtent.ymin < extent.ymax - tolerance
    )
      cross = true;
  } else {
    var polygon1 = trufPolygon([
      [
        [extent.xmin, extent.ymin],
        [extent.xmin, extent.ymax],
        [extent.xmax, extent.ymax],
        [extent.xmax, extent.ymin],
        [extent.xmin, extent.ymin],
      ],
    ]);
    var polygon2 = trufPolygon([
      [
        [dataExtent.xmin, dataExtent.ymin],
        [dataExtent.xmin, dataExtent.ymax],
        [dataExtent.xmax, dataExtent.ymax],
        [dataExtent.xmax, dataExtent.ymin],
        [dataExtent.xmin, dataExtent.ymin],
      ],
    ]);
    cross = booleanIntersects(polygon1, polygon2);
  }
  return cross;
}

// 切片相关
/**
 * @author: wyt
 * @description:拖拽后执行的操作
 * @param {*} vectorLayerData 图层数据
 * @param {*} firstTimestamp 时间戳
 * @param {*} lastExtent 上一次地图范围
 * @param {*} nowExtent 当前地图范围
 * @return {*}
 */
async function ProcessAfterDrag(
  layerNode,
  firstTimestamp,
  lastExtent,
  nowExtent,
  hasnotDrawRowCol
) {
  var layerId = layerNode.Id;
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  var coordinate = layerInfo.coordinate;
  store.dispatch("setStopLoading", false);

  // if (hasnotDrawRowCol.length > 0) {

  //   //拖拽后清除超出部份标注数据
  //   DTPLabel.clearPointLableData(layerId);
  //   //标注canvas重置位置
  //   DTPLabel.labelCanvasoffset(layerId);
  //   DTPLabel.clearLabelCanvas(layerId);
  //   //绘制还在范围内的标注
  //   DTPLabel.drawTilelabelData(layerId);
  // }

  //先获取数据库数据，再获取切片数据
  await getChangedData(layerId, "drag").then((res) => {
    // 行列数据
    drag_getTileData(
      hasnotDrawRowCol,
      layerNode,
      layerInfo,
      coordinate,
      firstTimestamp
    );
  });
}

/**
 * @author: wyt
 * @description:加载数据库数据
 * @export
 * @param {*} layerId 图层Id
 * @param {*} type 类型
 */
export function getChangedData(layerId, type, otherData) {
  return new Promise(function (resolve, reject) {
    if (!isInScale(layerId)) {
      return;
    }
    store.dispatch("setStopLoading", false);

    clearArcLineArr(layerId, null, "layer");
    ChangedCanvasCache = ChangedCanvasCache.filter(
      (ele) => ele.layerId != layerId
    );

    // console.log(store.state.allLayerData)
    var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
    if (layerInfo == undefined) {
      return;
    }
    //转换map的extent
    let coordinate = layerInfo.coordinate;
    var extent = map.extent;
    if (mapCoordinateNumber != coordinate) {
      extent = convertMapExtent(coordinate);
    }
    if (extent == null) {
      return;
    }

    allTotalLayerPost++;
    if (type == "drag") {
      totalPostCounts++;
    }

    var timeStamp = localStorage.getItem("timestamp" + layerId);
    var clienttimestamp = localStorage.getItem("clienttimestamp" + layerId);
    var nowtimestamp = new Date().getTime();
    //if (Math.abs(nowtimestamp - clienttimestamp) < Intervaltime && type != "reload") {
    //修改后：只有手动重新加载图层数据，才会去服务器获取新数据
    if (type != "init" && type != "reload") {
      var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
      //单独更新ChangedData
      updateChangedData(extent, layerId, layerInfo);
      if (type === "drag") {
        hasPostedCounts++;
      }
      allTotalLayerHasPosted++;
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);
      //拖拽后清除超出部份标注数据
      // DTPLabel.clearPointLableData(layerInfo.Id);
      //标注canvas重置位置
      // DTPLabel.labelCanvasoffset(layerInfo.Id);
      // DTPLabel.clearLabelCanvas(layerInfo.Id);
      resolve(otherData);
      //绘制还在范围内的标注（数据库数据除外）
      DTPLabel.drawTilelabelData(layerInfo.Id);
      if (type === "drag") {
        var changeD = AllChangedData.find((val) => val.layerId === layerId);
        if (!changeD) return;
        var viewdata = changeD.data.filter((ele) => ele.IsInView == true);
        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(
            (labelData) => {
              layerId, viewdata, "Attribute", type;
              DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
            }
          );
        } else {
          // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
          //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
          // });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find((val) => val.layerId === layerId);
          if (changeD) {
            DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
      return;
    }

    let params = {
      UserId: store.state.user.mapUserId,
      GDataId: layerInfo.GDataId,
      GDataName: "",
      type: 1,
      mapDocId: layerInfo.MapDocId,
      timestamp: timeStamp,
    };
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    cancleToken.push(source);
    getAllTableData(params, source.token).then(async (res) => {
      //保存下次请求的时间戳
      localStorage.setItem("timestamp" + layerId, res.data.timestamp);
      localStorage.setItem("clienttimestamp" + layerId, new Date().getTime());

      //更新切片版本
      // var newCacheVersion = {
      //   layerId: layerId,
      //   CacheVersion: res.data.CacheVersion,
      // };
      // var CacheVersionIndex = CacheVersionArray.findIndex(
      //   (val) => val.layerId == layerId
      // );
      // if (CacheVersionIndex > -1) {
      //   CacheVersionArray.splice(CacheVersionIndex, 1);
      //   CacheVersionArray.push(newCacheVersion);
      // } else {
      //   CacheVersionArray.push(newCacheVersion);
      // }

      ZHT_ChangedDelData = res.data.deleteids;

      if (res.data != "") {
        var deleteArr = [];
        if (res.data.lis) {
          for (var i = 0; i < res.data.lis.length; i++) {
            deleteArr.push(res.data.lis[i].ID);
          }
        }
        if (res.data.deleteids) {
          deleteArr.push(...res.data.deleteids);
        }
      }
      deleteArr = deleteArr ? deleteArr : [];
      var deleteObj = {
        layerId: layerId,
        IDs: deleteArr,
      };
      if (notDrawIDs.findIndex((val) => val.layerId == layerId) > -1) {
        var repeatIndex = notDrawIDs.findIndex((val) => val.layerId == layerId);
        notDrawIDs[repeatIndex].IDs = MergeArray(
          notDrawIDs[repeatIndex].IDs,
          deleteArr
        );
      } else {
        notDrawIDs.push(deleteObj);
      }
      resolve(otherData);
      var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
      //处理数据库缓存数据,更新AllChangedData

      if (
        (res.data.lis && res.data.lis.length > 0) ||
        (res.data.deleteids && res.data.deleteids.length > 0)
      ) {
        updateAllChangedData(res.data.lis, extent, layerId, layerInfo);
      } else {
        //单独更新ChangedData
        updateChangedData(extent, layerId, layerInfo);
      }
      //设置该图层已加载数据
      layerInfo.hasLoadData = true;

      if (type === "drag") {
        hasPostedCounts++;
      }
      allTotalLayerHasPosted++;
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);
      //拖拽后清除超出部份标注数据
      // DTPLabel.clearPointLableData(layerInfo.Id);
      //标注canvas重置位置
      // DTPLabel.labelCanvasoffset(layerInfo.Id);
      // DTPLabel.clearLabelCanvas(layerInfo.Id);
      //绘制还在范围内的标注（数据库数据除外）
      // DTPLabel.drawTilelabelData(layerInfo.Id);
      if (type === "drag") {
        var changeD = AllChangedData.find((val) => val.layerId === layerId);
        if (!changeD) return;
        var viewdata = changeD.data.filter((ele) => ele.IsInView == true);
        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          await DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(
            (labelData) => {
              layerId, viewdata, "Attribute", type;
              DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
            }
          );
        } else {
          // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
          //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
          // });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find((val) => val.layerId === layerId);
          if (changeD) {
            DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
    });
  });
}
function MergeArray(arr1, arr2) {
  var _arr = new Array();
  for (var i = 0; i < arr1.length; i++) {
    _arr.push(arr1[i]);
  }
  for (var i = 0; i < arr2.length; i++) {
    var flag = true;
    for (var j = 0; j < arr1.length; j++) {
      if (arr2[i] == arr1[j]) {
        flag = false;
        break;
      }
    }
    if (flag) {
      _arr.push(arr2[i]);
    }
  }
  console.log("22",_arr);
  return _arr;
}

/**
 * @author: wyt
 * @description:加载行列切片数据
 * @export
 * @param {*} vectorLayerData 图层数据
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 */
function addTileData(vectorLayerData, mouseType, firstTimestamp) {
  var layerId = vectorLayerData.id ? vectorLayerData.id : vectorLayerData.Id;

  //删除当前图层的缓存数据
  // TileData = TileData.filter(ele => ele.layerId != layerId);
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var rowcol = getRowCol(map.extent);
  hasnotDrawRowCol = [];
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      allTotalLayerPost++;
      hasnotDrawRowCol.push({
        row: i,
        col: j,
      });
      getTileData(
        i,
        j,
        mouseType,
        vectorLayerData,
        layerInfo.coordinate,
        firstTimestamp
      );
    }
  }
}

/**
 * @author: wyt
 * @description:取行列切片数据
 * @export
 * @param {*} i 行号
 * @param {*} j 列号
 * @param {*} mouseType 类型
 * @param {*} vectorLayerData 图层数据
 * @param {*} coordinate 坐标
 * @param {*} firstTimestamp 时间戳
 */
export async function getTileData(
  i,
  j,
  mouseType,
  vectorLayerData,
  coordinate,
  firstTimestamp
) {
  var level = map.getLevel();
  var pageType = 0;
  var layerId = vectorLayerData.id ? vectorLayerData.id : vectorLayerData.Id;
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  // 判断是否需要加参数
  var para = isAddToParams(layerId);
  var isImg = "v";

  if (mouseType == "drag") {
    totalPostCounts++;
  } else {
    lastNumber++;
  }
  // 暂时写死（底图底图id）
  var basemapID = 2;
  // if (pageType == 0) {
  //   // store.state.SingleData.BMPID  在线影像的时候用这个
  //   basemapID = store.state.SingleData.Gdata_data
  //     ? store.state.SingleData.Gdata_data.BMPId
  //     : store.state.SingleData.BMPID;
  // } else {
  //   basemapID = store.state.SingleData.BMPId;
  // }
  // 暂时写死
  var CacheVersion = "";
  // var CacheVersionIndex = CacheVersionArray.findIndex(
  //   (val) => val.layerId == layerId
  // );
  // if (CacheVersionIndex > -1) {
  //   CacheVersion = CacheVersionArray[CacheVersionIndex].CacheVersion;
  // }
  var params = {
    UserId: store.state.user.mapUserId,
    GDataId: vectorLayerData.gDataId
      ? vectorLayerData.gDataId
      : vectorLayerData.GDataId,
    Coordinate: coordinate,
    Level: level,
    Row: i,
    Column: j,
    type:  1,
    mapDocId: layerInfo.MapDocId,
    tiletype: isImg,
    BMPId: basemapID,
    CacheVersion: CacheVersion,
  };
  params = Object.assign(params, para);
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  cancleToken.push(source);

  getGDataObject(params, source.token)
    .then(async (result) => {
      if (mouseType == "drag") {
        hasPostedCounts++;
      } else {
        currentNumber++;
      }

      allTotalLayerHasPosted++;
      var obj = result.config.params;
      var nCol = obj.Column;
      var nRow = obj.Row;
      var nLevel = obj.Level;
      if (result.data.T != 0) {
        var offset = getCoordByRowCol(nRow, nCol);
        var flag = true;
        if (mouseType == "scale") {
          if (firstTimestamp != zoomEndTimestamp) {
            flag = false;
          }
        }
        if (flag) {
          //图片切片
          if (result.data.T == 1) {
            //绘制图片
            startDrawImage(
              nRow,
              nCol,
              offset,
              result.data,
              layerId,
              mouseType,
              firstTimestamp
            );
          }
          //矢量切片因数据量过大，还未生成切片
          else if (result.data.T === 3) {
            var canvas = ZHT_creatCanvas(layerId, offset, nRow, nCol, true);
            if (canvas) {
              canvas.style.border = "1px solid red";
              var ctx = canvas.getContext("2d");
              ctx.font = '12px "微软雅黑"';
              ctx.fillStyle = "red";
              var space = 256 / 2;
              ctx.fillText("此区域数据量过大，", space - 40, space);
              ctx.fillText("需手动切片后显示", space - 40, space + 20);
            }
          }
          //正常矢量切片
          else {
            var newData = convertData(
              nRow,
              nCol,
              result.data,
              layerInfo.GeoType
            );
            var obj = {
              layerId: layerId,
              geoType: vectorLayerData.geoType
                ? vectorLayerData.geoType
                : vectorLayerData.GeoType,
              data: result.data,
              row: nRow,
              col: nCol,
              offset: offset,
            };
            //剔除修改或删除的要素
            obj = changeObjData(obj);
            //判断共享类型，剔除不可显示要素
            var shareIndex = shareStatus.findIndex(
              (val) => parseInt(val.gDataId) == layerInfo.GDataId
            );
            if (shareIndex >= 0) {
              if (
                shareStatus[shareIndex].status == 3 ||
                shareStatus[shareIndex].status == 4 ||
                shareStatus[shareIndex].status == 5
              ) {
                obj = getShareObj(obj);
              }
            }

            if (obj) {
              TileData.push(obj);
            }

            //开始绘制图形
            if (
              shareIndex >= 0 &&
              (shareStatus[shareIndex].status == 3 ||
                shareStatus[shareIndex].status == 5)
            ) {
              startDraw(
                nRow,
                nCol,
                offset,
                obj.data,
                layerId,
                mouseType,
                firstTimestamp
              );
            } else {
              startDraw(
                nRow,
                nCol,
                offset,
                newData,
                layerId,
                mouseType,
                firstTimestamp
              );
            }

            //判断图层是否有标注
            let alllayers = store.state.allLayerData;
            let obj1 = alllayers.find((x) => x.Id === layerId);
            if (obj1 == undefined || obj.Label == "") {
              return;
            }
            let labels = JSON.parse(obj.Label);
            if (!labels.Visiable) {
              return;
            }

            //切片上的坐标转换成canvas上要绘制的坐标
            var newData2 = DTPLabel.labelConvertData(
              nRow,
              nCol,
              result.data,
              layerInfo.GeoType
            );
            //开始绘制标注
            DTPLabel.DrawLayerLabel(layerId, newData2.J, "Vector", mouseType);
          }
        }
      } else {
        //标注图层渲染
        // if (mouseType == "drag") {
        //   if (allTotalLayerHasPosted === allTotalLayerPost) {
        //
        //     DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Vector", mouseType);
        //   }
        // }
        if (allTotalLayerHasPosted === allTotalLayerPost) {
          stopDrawText();
        }
      }
      //绘制完后，将此行列从未绘制行列hasnotDrawRowCol中移除
      var index = hasnotDrawRowCol.findIndex(
        (x) => (x.row = obj.Row && x.col == obj.Column)
      );
      hasnotDrawRowCol.splice(index, 1);
    })
    .catch((e) => {
      if (axios.isCancel(e)) {
      } else {
      }
    });
}

/**
 * @author: wyt
 * @description:判断是否需要加参数
 * @export
 * @param {*} layerId 图层Id
 * @return {*}
 */
function isAddToParams(layerId) {
  var layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  let layerSym = JSON.parse(layerInfo.Symbol);
  var para = {
    isrender: false,
    fieldname: "",
    layerid: 0,
    isTag: false,
    // Tagname: ""
  };
  if (layerSym.hasOwnProperty("FieldName")) {
    var obj = {
      isrender: true,
      fieldname: "",
      layerid: getPageType() == 1 ? layerId : 0,
    };
    para = Object.assign(para, obj);
  }
  if (layerInfo.Label.trim() != "") {
    var labelInfo = JSON.parse(layerInfo.Label);
    var obj = {
      isTag: true,
      // Tagname: labelInfo.LabelField,
      layerid: getPageType() == 1 ? layerId : 0,
    };
    para = Object.assign(para, obj);
  }
  return para;
}

/**
 * @author: wyt
 * @description:转换数据（点转屏幕）
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} olddata
 * @param {*} geoType 数据类型
 * @return {*}
 */
function convertData(row, col, olddata, geoType) {
  // var data = allData.filter(x=>x.J[i].G != null &&x.J[i].G.length == 0);
  // var data = {};
  // data = JSON.parse(JSON.stringify(olddata));
  var data = commonB.deepClone(olddata);
  // var data = olddata;
  var newData = [];
  var obj = {};

  if (data == "") {
    let d = {
      J: [],
    };
    return d;
  }
  if (!data.J || !data.J.length) {
    data.J = [];
    return data;
  }
  for (var i = 0; i < data.J.length; i++) {
    if (data.J[i].G == null || data.J[i].G.length == 0) {
      continue;
    }
    if (data.J[i].G.length > 0) {
      var gdata = data.J[i].G;
      var newd = [];
      for (var k = 0; k < gdata.length; k++) {
        var singledata = gdata[k];
        singledata = singledata.filter((ele) => {
          return ele != null;
        });
        if (geoType == "面") {
          // if (singledata.length < 4) {
          //   continue;
          // } else {
          newd.push(singledata);
          // }
        } else if (geoType == "线") {
          if (singledata.length < 2) {
            continue;
          } else {
            newd.push(singledata);
          }
        } else {
          // var rowcol = getRowCol(map.extent);
          // var pdata = []
          // for (var j = 0; j < singledata.length; j++) {
          //   var rowcol = getRowCol(map.extent);
          //   var x = singledata[j][0] + 256 * (col - rowcol.minCol);
          //333333333333   var y = singledata[j][1] + 256 * (rowcol.maxRow - row);
          //   pdata.push([x, y])
          // }
          // newd.push(pdata)
          newd.push(singledata);
        }
      }
      if (newd.length > 0) {
      }
      data.J[i].G = newd;
    }
  }
  return data;
}

//切片数据中移出
function changeObjData(obj) {
  if (notDrawIDs.findIndex((val) => val.layerId == obj.layerId) > -1) {
    var repeatIndex = notDrawIDs.findIndex((val) => val.layerId == obj.layerId);
    for (var i = 0; i < obj.data.J.length; i++) {
      for (var j = 0; j < notDrawIDs[repeatIndex].IDs.length; j++) {
        if (obj.data.J[i].O == notDrawIDs[repeatIndex].IDs[j]) {
          obj.data.J.splice(i, 1);
          i--;
          if (i < 0) {
            i = 0;
          }
          continue;
        } else {
          continue;
        }
      }
    }
  }
  return obj;
}

/**
 *创建一块256的canvas
 * @param {图层id} layerId
 * @param {偏移量} offset
 * @param {行} row
 * @param {列} col
 * @param {是否是边框样式} isBorder
 * @returns
 */
export function ZHT_creatCanvas(layerId, offset, row, col, isBorder) {
  let layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  var canvasCtn = createTiledCanvas(layerId);
  var ele = document.getElementById(layerId + "_" + row + "_" + col);
  if (ele) {
    ele.style.left = offset.offsetX + "px";
    ele.style.top = offset.offsetY + "px";
    if (layerInfo.GeoType === "点" || layerInfo.GeoType === "线") {
      ele.style.left = offset.offsetX - pointSpace + "px";
      ele.style.top = offset.offsetY - pointSpace + "px";
    }
    return;
  }
  var canvas = document.createElement("canvas");
  canvas.className = "gispaiLayer";
  canvas.style.left = offset.offsetX + "px";
  canvas.style.top = offset.offsetY + "px";
  canvas.setAttribute("id", layerId + "_" + row + "_" + col);
  canvas.setAttribute("targetType", "data");
  canvasCtn.append(canvas);
  canvas.width = 256;
  canvas.height = 256;
  if ((layerInfo.GeoType === "点" || layerInfo.GeoType === "线") && !isBorder) {
    canvas.width = pointCanvasWidth;
    canvas.height = pointCanvasWidth;
    canvas.style.left = offset.offsetX - pointSpace + "px";
    canvas.style.top = offset.offsetY - pointSpace + "px";
  }
  canvas.style.position = "absolute";
  return canvas;
}

/**
 * @author: wyt
 * @description:绘制canvas
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} offset 偏移量
 * @param {*} data
 * @param {*} oridata 旧数据
 * @param {*} layerId 图层Id
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 * @return {*}
 */
export function startDraw(
  row,
  col,
  offset,
  data,
  layerId,
  mouseType,
  firstTimestamp
) {
  var canvas = ZHT_creatCanvas(layerId, offset, row, col);
  let layerInfo = allLayerInfoList.find((ele) => ele.Id == layerId);
  // commonB.sortVirtualHandle(layerId, data);
  drawOnCanvas(
    layerId,
    row,
    col,
    canvas,
    layerInfo,
    data,
    "real",
    mouseType,
    firstTimestamp
  );
  // if (mouseType != "redraw") {
  drawPolygonOnCacheCanvas(
    row,
    col,
    layerId,
    data,
    layerInfo,
    mouseType,
    firstTimestamp,
    offset
  );
  // }
}

/**
 * @author: wyt
 * @description: 绘制缓存的canvas
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} layerId 图层Id
 * @param {*} data
 * @param {*} oridata 旧数据
 * @param {*} layerInfo 图层数据
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 * @param {*} offset 偏移量
 */
function drawPolygonOnCacheCanvas(
  row,
  col,
  layerId,
  data,
  layerInfo,
  mouseType,
  firstTimestamp,
  offset
) {
  if (!isInScale(layerId)) {
    return;
  }
  var tmp = -1;
  tmp = TileCanvasCache.findIndex((ele) => {
    return ele.layerId == layerId && ele.row == row && ele.col == col;
  });
  var canvas = document.createElement("canvas");
  canvas.setAttribute("id", layerId + "_" + row + "_" + col);
  canvas.width = 256;
  canvas.height = 256;
  canvas.style.left = offset.offsetX + "px";
  canvas.style.top = offset.offsetY + "px";
  if (layerInfo.GeoType == "点" || layerInfo.GeoType == "线") {
    canvas.width = pointCanvasWidth;
    canvas.height = pointCanvasWidth;
    canvas.style.left = offset.offsetX + pointSpace + "px";
    canvas.style.top = offset.offsetY + pointSpace + "px";
  }
  if (tmp == -1) {
    var context = canvas.getContext("2d");
    var obj = {
      layerId: layerId,
      geoType: layerInfo.GeoType,
      cacheContext: context,
      cacheCanvas: canvas,
      data: data,
      row: row,
      col: col,
    };
    drawOnCanvas(
      layerId,
      row,
      col,
      canvas,
      layerInfo,
      data,
      "cache",
      mouseType,
      firstTimestamp
    );
    TileCanvasCache.push(obj);
  }
}

/**
 * @author: wyt
 * @description:  *绘制不规则图形 *canvas:画布对象*style:样式/格式对象*data:三维数组
 * @param {*} layerId 图层Id
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} canvas
 * @param {*} layerInfo 图层数据
 * @param {*} data
 * @param {*} type 数据类型
 * @param {*} mouseType 操作类型
 * @param {*} firstTimestamp 时间戳
 * @return {*} drawType 绘制类型:  导出大图“export”
 */
export async function drawOnCanvas(
  layerId,
  row,
  col,
  canvas,
  layerInfo,
  data,
  type,
  mouseType,
  firstTimestamp,
  drawType
) {
  // 判断图层在范围内
  if (!isInScale(layerId)) {
    // if (allTotalLayerHasPosted === allTotalLayerPost) {
    stopDrawText();
    // }
    return;
  } else {
    startDrawText();
  }
  if (!canvas) {
    return;
  }
  let context = canvas.getContext("2d");
  let layerSym = JSON.parse(layerInfo.Symbol);
  var color;
  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
  var label = "";

  if (layerInfo.Symbol) {
    label = JSON.parse(layerInfo.Symbol).FieldName;
  }
  var isRender = false;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  if (type != "cache") {
    //未绘制的行列号数据
    noDrawData.push({
      layerId: layerId,
      row: row,
      col: col,
    });
  }
  var style = {
    set: {
      url: "",
    },
  };
  //if (type != "cache") {
  // 简单渲染
  if (!isRender) {
    // 获取点线面的符号样式
    style = getCanvasStyle(layerInfo, "", symbol);
    for (let key in style.style) {
      context[key] = style.style[key];
    }

    if (layerInfo.GeoType === "线") {
      // 复合线样式有值，遍历多条线绘制形成复合线
      if (style.set.lineStyles.length) {
        style.set.lineStyles.forEach((val) => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          commonB.drawOnCanvas_noRenderDraw(
            layerId,
            row,
            col,
            canvas,
            layerInfo,
            data,
            type,
            mouseType,
            firstTimestamp,
            val,
            color,
            context,
            "",
            "",
            "",
            drawType
          );
        });
      } else {
        commonB.drawOnCanvas_noRenderDraw(
          layerId,
          row,
          col,
          canvas,
          layerInfo,
          data,
          type,
          mouseType,
          firstTimestamp,
          style,
          color,
          context,
          "",
          "",
          "",
          drawType
        );
      }
    } else if (layerInfo.GeoType === "面") {
      if (style.set.lineStyles && style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async (val) => {
          commonB.drawOnCanvas_noRenderDraw(
            layerId,
            row,
            col,
            canvas,
            layerInfo,
            data,
            type,
            mouseType,
            firstTimestamp,
            val,
            color,
            context,
            "",
            "",
            "",
            drawType
          );
        });
      } else {
        commonB.drawOnCanvas_noRenderDraw(
          layerId,
          row,
          col,
          canvas,
          layerInfo,
          data,
          type,
          mouseType,
          firstTimestamp,
          style,
          color,
          context,
          "",
          "",
          "",
          drawType
        );
      }
    } else {
      commonB.drawOnCanvas_noRenderDraw(
        layerId,
        row,
        col,
        canvas,
        layerInfo,
        data,
        type,
        mouseType,
        firstTimestamp,
        style,
        color,
        context,
        "",
        "",
        "",
        drawType
      );
    }
  } else {
    //唯一值、分级渲染情况下，单独获取渲染值字段进行绘制
    commonB
      .getUniRenderLabelVals(layerId, data.J, label, "vector")
      .then((res) => {
        var keys = Object.keys(res);
        commonB.drawOnCanvas_noRenderDraw(
          layerId,
          row,
          col,
          canvas,
          layerInfo,
          data,
          type,
          mouseType,
          firstTimestamp,
          style,
          color,
          context,
          keys,
          res,
          symbol,
          drawType
        );
      });
  }
}

//新增以及之前未绘制的行列号
function drag_getTileData(
  arr,
  layerNode,
  layerInfo,
  coordinate,
  firstTimestamp
) {
  for (var i = 0; i < arr.length; i++) {
    if (layerInfo.GeoType == "点") {
      if (firstTimestamp != dragEndTimestamp) {
        return false;
      }
    }

    allTotalLayerPost++;
    getTileData(
      arr[i].row,
      arr[i].col,
      "drag",
      layerNode,
      coordinate,
      firstTimestamp
    );
  }
}

/** 拾取相关 **/
/**
 * @author: wyt
 * @description: 鼠标拾取canvas
 * @param {*} evt 地图屏幕坐标
 */
function mouseMoveEvent(evt, client) {
  // let toolList = ["multi_point", "point", "polyline", "polygon", "CIRCLE", "rectangle", "arc_line", "sectors",
  //   "drawCircle", "splittool",
  //   "reshapetool", "SplitLine", "AddInnerRing", "movepvetex", "movelvetex", "movepolygons", "moveline"
  // ]
  // let selectTool = ["SelectByRectangle", "SelectByPolygon", "SelectByCircle", "SelectByPolyline",
  //   "SelectNodeByRectangle", "measure"
  // ]
  // if (selectTool.indexOf(current_tool) != -1) {
  //   return
  // }
  // if (ISStartEditing && IsToolActive && toolList.indexOf(current_tool) != -1) {
  //   return
  // }
  // map.setMapCursor("default");
  var ele = document.getElementsByClassName("highlightLayer");
  if (ele && ele.length > 0) {
    for (var i = 0; i < ele.length; i++) {
      var ctx = ele[i].getContext("2d");
      ctx.clearRect(0, 0, ele[i].width, ele[i].height);
    }
  }
  // lastPickedData = [];
  //图层排序
  reorderPickedLayer("highlight");
  //总图层关闭
  // if (store.state.dataTreeData.length > 0 && !store.state.dataTreeData[0].checked) {
  //   return;
  // }
  // console.log("TileCanvasCache", TileCanvasCache);
  //按图层顺序，从上往下
  // var vNodes = getVetorLayerNode(store.state.dataTreeData);
  // var layerArr = [];
  // var layerCacheArr = [];
  // for (var i = 0; i < vNodes.length; i++) {
  //   let flag = getChecked(vNodes[i]);
  //   // 判断勾选并且允许被拾取
  //   // vNodes[i].IsPicked => 是否允许被拾取
  //   if (flag && vNodes[i].IsPicked) {
  //     let cd = TileCanvasCache.filter(ele => ele.layerId === vNodes[i].id);
  //     layerArr = layerArr.concat(cd);
  //     let ccd = ChangedCanvasCache.find(ele => ele.layerId === vNodes[i].id);
  //     if (ccd) {
  //       layerCacheArr.push(ccd);
  //     }
  //   }
  // }
  // console.log("ChangedCanvasCache",ChangedCanvasCache);
  // console.log("layerCacheArr",layerCacheArr);
  // layerCacheArr.length > 0 ?
  //   pickupTmpCanvas(layerCacheArr, layerArr, evt) :
  //   pickedCanvasSelected(TileCanvasCache, evt);
  // pickedCanvasSelected(TileCanvasCache, evt, client);
}

/**
 * 拾取图层canvas顺序
 * @param {*} name 类名
 */
export function reorderPickedLayer(name) {
  var canvasCtn = document.querySelector(".gispaiLayer_" + name);
  // var vNodes = getVetorLayerNode(store.state.dataTreeData);
  // var baseList = store.state.baseTreeData[0].children;
  var div = document.querySelector("#mapView_gc");
  if (canvasCtn) {
    div.before(canvasCtn);
    canvasCtn.style.zIndex = 99999;
  }
}
/**
 * @author: wyt
 * @description: 拾取行列号canvas
 * @param {*} tmp 满足当前行列的数据
 * @param {*} position x,y坐标
 */
function pickedCanvasSelected(layerArr, evt, client) {
  var isVlaue = false;
  var position;
  //var obj = getSingleRowCol(evt.layerX, evt.layerY)
  var curRowCol = getSingleRowCol(evt.x, evt.y); //当前所在行列

  var tmp = layerArr.filter((ele) => {
    return ele.row == curRowCol.row && ele.col == curRowCol.col;
  });

  if (tmp.length > 0) {
    position = {
      x: curRowCol.colp,
      y: curRowCol.rowp,
    };
  }
  for (var i = 0; i < tmp.length; i++) {
    var color = "";
    if (tmp[i].geoType == "点" || tmp[i].geoType == "线") {
      //var rowcol = getRowCol(map.extent);
      var pos = {};
      // pos.x = position.x + 256 * (tmp[i].col - rowcol.minCol);
      // pos.y = position.y + 256 * (rowcol.maxRow - tmp[i].row);
      pos.x = position.x + pointSpace;
      pos.y = position.y + pointSpace;
      color = getCacheColor(pos, tmp[i].cacheContext);
    } else {
      color = getCacheColor(position, tmp[i].cacheContext);
    }
    if (color) {
      isVlaue = true;
      var selectIndex = ex16hex(color);
      if (selectIndex != 0 && selectIndex != NaN) {
        var shape = tmp[i].data.J[selectIndex - 1];
        if (shape) {
          map.setMapCursor("pointer");
          var dataID = shape.O;
          var tmpD = TileCanvasCache.filter(
            (ele) => ele.layerId == tmp[i].layerId
          );
          var newData = [];
          let newPointData = [];
          for (var j = 0; j < tmpD.length; j++) {
            if (tmpD[j].data.J != null) {
              var tempJ = convertData(
                tmpD[j].row,
                tmpD[j].col,
                tmpD[j].data,
                tmpD[j].geoType
              );
              var temp = tempJ.J;
              if (tmp[i].geoType == "点") {
                let pdata = temp.filter(
                  (ele) => ele.G != null && ele.G.length > 0 && ele.O == dataID
                );
                if (pdata.length > 0) {
                  let obj = {
                    row: tmpD[j].row,
                    col: tmpD[j].col,
                    data: pdata,
                  };
                  newPointData.push(obj);
                }
              }
              var data = temp.filter(
                (ele) => ele.G != null && ele.G.length > 0 && ele.O == dataID
              );
              if (data.length > 0) {
                let obj = {
                  row: tmpD[j].row,
                  col: tmpD[j].col,
                  data: data,
                };
                newData.push(obj);
              }
            }
          }
          let pickedObj = {
            layerId: tmp[i].layerId,
            data: newData,
            Id: dataID,
            type: "screen",
            geoType: tmp[i].geoType,
            data: tmp[i].geoType == "点" ? newPointData : newData,
            // data: newData
          };
          if(store.state.sliceCanvasInfo.id) {
            if(store.state.sliceCanvasInfo.id !== dataID) {
              store.commit('set_mousePosition',{ top: client.clientY, left: client.clientX})
              store.commit('setSliceCanvasInfo', {layerId:tmp[i].layerId, id:dataID})
            }
          }else {
            store.commit('set_mousePosition',{ top: client.clientY, left: client.clientX})
            store.commit('setSliceCanvasInfo', {layerId:tmp[i].layerId, id:dataID})
          }
          lastPickedData.push(pickedObj);
          //若canvas关闭，则开启
          let pickedele = document.querySelector(".gispaiLayer_highlight");
          if (pickedele && pickedele.style.display == "none") {
            pickedele.style.display = "block";
          }
          // if (!store.state.keyCode.ctrlKey) {
          // console.log(tmp[i]);
          // console.log(newData);
          redrawData(tmp[i].layerId, newData, "highlight");
          // }
          break;
        }
      }
    } else {
      store.commit('setSliceCanvasInfo', -1)
    }
  }
  return isVlaue;
}

/**
 * @author: wyt
 * @description: 绘制选择的数据/高亮
 * @export
 * @param {*} layerId 图层Id
 * @param {*} newdata 数据
 * @param {*} name canvas id
 */
export async function redrawData(layerId, newdata, name) {
  // if (!isInScale(layerId) || !commonB.isLayerSelect(layerId)) {
  //   stopDrawText();
  //   return;
  // } else {
  //   startDrawText();
  // }

  var layerInfo = allLayerInfoList.find(ele => ele.Id == layerId);
  let layerSym = JSON.parse(layerInfo.Symbol);
  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";

  var isRender = false;
  let style = {};
  var canvas;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  // 点符号特殊处理
  if (layerInfo.GeoType === "点" && isRender) {
    for (var l = 0; l < newdata.length; l++) {

      await commonB
        .getUniRenderLabelVals(
          layerId,
          newdata[l].data,
          layerSym.FieldName,
          "Vector"
        )
        .then(res => {
          var alldata = newdata[l].data,
            context,
            pointContext,
            pointSelectedCanvas;
          canvas = document.getElementById(
            name + "_" + newdata[l].row + "_" + newdata[l].col
          );
          if (layerInfo.GeoType === "点") {
            pointSelectedCanvas = document.getElementById(
              name + "_" + newdata[l].row + "_" + newdata[l].col + "_point"
            );
          }
          if (pointSelectedCanvas) {
            pointContext = pointSelectedCanvas.getContext("2d");
            pointContext.beginPath();
          }
          if (canvas) {
            context = canvas.getContext("2d");
          }
          // var context = canvas.getContext("2d")
          context.beginPath();
          var keys = Object.keys(res);
          for (var k = 0; k < alldata.length; k++) {
            let index = keys.findIndex(key => key === alldata[k].O + "");
            var attrValue = res[keys[index]];
            var data = alldata[k];
            style = commonB.newGetCanvasStyle(layerInfo, attrValue, symbol);
            for (var i = 0; i < data.G.length; i++) {
              if (data.G[i] == null || data.G[i].length == 0) {
                continue;
              }
              var singledata = data.G[i];
              singledata = singledata.filter(ele => {
                return ele != null;
              });
              for (var j = 0; j < singledata.length; j++) {

                if (layerInfo.GeoType == "点") {
                  var x = singledata[j][0] + pointSpace;
                  var y = singledata[j][1] + pointSpace;
                  if (style.set.url) {
                    pointContext.fillStyle = "#00FFFF";
                    pointContext.arc(
                      x + cacheImageOffset,
                      y + cacheImageOffset,
                      style.set.width / 2,
                      0,
                      Math.PI * 2
                    );
                    pointContext.fill();
                    // loadCompleted("../../../static/images/arc.png").then((img) => {
                    //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                    // })
                  } else {
                    let _style = commonB.deepClone(style);
                    _style.set.color = "#00FFFF";
                    pointCtx.ctx.iconFont(
                      pointSelectedCanvas,
                      pointCtx.ctx.iconFontStyle(_style, x, y)
                    );
                  }
                } else {
                  if (layerInfo.GeoType == "面") {
                    // if (singledata.length < 4) {
                    //   continue;
                    // }
                  } else {
                    if (singledata.length < 2) {
                      continue;
                    }
                  }
                  if (singledata.length < 2) {
                    context.moveTo(singledata[j][0], singledata[j][1]);
                    context.lineTo(singledata[j][0] + 1, singledata[j][1]);
                  } else {
                    if (j == 0) {
                      context.moveTo(singledata[j][0], singledata[j][1]);
                    } else {
                      context.lineTo(singledata[j][0], singledata[j][1]);
                    }
                  }
                }
              }
              setCanvasPicked(layerInfo.GeoType, context, style);
            }
          }
        });
    }
  } else {
    // 获取样式
    style = commonB.newGetCanvasStyle(layerInfo, "", symbol);
    for (var l = 0; l < newdata.length; l++) {
      if (layerInfo.GeoType === "线") {
        if (style.set.lineStyles.length) {
          style.set.lineStyles.forEach(val => {
            commonB.redrawData_noRender(
              layerInfo,
              canvas,
              newdata[l],
              name,
              val
            );
          })
        } else {
          commonB.redrawData_noRender(
            layerInfo,
            canvas,
            newdata[l],
            name,
            style
          );
        }
      } else {
        commonB.redrawData_noRender(
          layerInfo,
          canvas,
          newdata[l],
          name,
          style
        );
      }
    }
  }
}

/**
 * @author: wyt
 * @description: 根据屏幕坐标取缓存canvas颜色
 * @export
 * @param {*} positon
 * @param {*} cacheContext 缓存canvas的context
 * @return {*}
 */
export function getCacheColor(positon, cacheContext) {
  if (!cacheContext) {
    return;
  }
  var color = cacheContext.getImageData(positon.x, positon.y, 1, 1).data;
  var hex = "";
  if (color[3] === 255) {
    hex = rgbToHex(color[0], color[1], color[2]);
  }
  return hex;
}

// 16进制数转10进制
function ex16hex(hex) {
  if (!hex) {
    return;
  }
  var len = hex.length,
    a = new Array(len),
    code;
  for (var i = 0; i < len; i++) {
    code = hex.charCodeAt(i);
    if (48 <= code && code < 58) {
      code -= 48;
    } else {
      code = (code & 0xdf) - 65 + 10;
    }
    a[i] = code;
  }
  return a.reduce(function (acc, c) {
    acc = 16 * acc + c;
    return acc;
  }, 0);
}

/**
 * @author: wyt
 * @description: rgb转hex
 * @param {*} r
 * @param {*} g
 * @param {*} b
 * @return {*}
 */
function rgbToHex(r, g, b) {
  return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

/**
 * @author: wyt
 * @description: 根据屏幕坐标，计算相应的行列号中的x，y
 * @export
 * @param {*} x
 * @param {*} y
 * @return {*}
 */
export function getSingleRowCol(x, y) {
  var esriModule = store.state.esriModule;
  // var resolution = 1.4078260157100582;
  // var level = map.getLevel();
  // var OriginX = -180;
  // var OriginY = -90;
  // if (map.spatialReference.wkid == 102100) {
  //     resolution = 156543.03392800014;
  //     OriginX = -20037508.342787;
  //     OriginY = -20037508.342787;
  // }

  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  var extent = map.extent;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  var res = map.__tileInfo.lods[level].resolution;
  let screenPoint = new esriModule.ScreenPoint(x, y);
  let point = map.toMap(screenPoint);
  var col = Math.floor((point.x - OriginX) / (res * 256));
  var row = Math.floor((point.y - OriginY) / (res * 256));
  var minx = col * res * 256 + OriginX;
  var miny = (row + 1) * res * 256 + OriginY;
  var colp = Math.abs((point.x - minx) / res);
  var rowp = Math.abs((point.y - miny) / res);
  return {
    row: row,
    col: col,
    colp: colp,
    rowp: rowp,
  };
}


export default databaseLayer;
